import * as R from 'ramda';
import * as CryptoJS from 'crypto-js';

import { Alert, Button, Col, Modal, OverlayTrigger, Spinner, Table, Tooltip } from 'react-bootstrap';
import {Button as MuiButton, Snackbar } from '@material-ui/core';
import { IAIEarth, IJob, IMap } from '../../store/aiearth/types';
import { ISearchRecord } from '../../types/search';
import { ChevronLeft } from 'react-feather';
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { ceresApp, buttonFavorite, iv, key as secKey, searchFavorite } from '../../services/firebase';
import {
  updateJob,
  resetJob,
  resetAir,
  resetAIEarth,
  updateAIEarth,
} from '../../store/aiearth/action';
import { useDispatch, useSelector } from 'react-redux';
import { centroid, multiLineString, multiPolygon, polygon } from '@turf/turf';
import MyTundraMap from './map/MyTundraMap';
import { FacilityModeDataProvider } from './map/FacilityModeDataContext';
import FacilityChatBubble from './FacilityChatBubble';
import { CeresLogger } from '../../logger';
import { setMapFindings, markerJson } from '../../util/mapFindings.util';
import { IAuthContext } from '../../context/auth/auth-context';
import MyTundraRecordMarker from './map/MyTundraRecordMarker';
import { TIERS } from '../../types/tiers';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import withAuthContext from '../../context/auth/AuthConsumer';
import ButtonOptions from './ButtonOptions';
import MyTundraFavoriteButtons from './MyTundraFavoriteButtons';
import { Link, useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';
import AddIcon from '@material-ui/icons/Add';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import AddFacilityModal from './AddFacilityModal';
import MyTundraTabResultsModal from './map/MyTundraTabResultsModal';
import { FiMaximize2, FiMinimize2 } from 'react-icons/fi';
import MyTundraMapsFinding from './MyTundraMapsFinding';
import MuiAlert from '@material-ui/lab/Alert';
import { API_BASE_URL, API_AUTH_HEADERS } from '../../util/api.util';
import {
  FACILITIES_INITIAL_PAGE_SIZE,
  FACILITIES_NEXT_PAGE_SIZE,
  HOMEPAGE_FACILITY_SLOT_COUNT,
  mapFavoritesPayload,
  normalizeFavoriteList,
  promoteFavoriteToHomepage,
  demoteFavoriteFromHomepage,
  HOMEPAGE_TOAST_ADDED,
  HOMEPAGE_TOAST_ADDING,
  HOMEPAGE_TOAST_ORDER_UPDATED,
  HOMEPAGE_TOAST_REMOVED,
  HOMEPAGE_TOAST_REMOVING,
  HOMEPAGE_TOAST_SAVING_ORDER,
  isHomepageFavorite,
  isValidLatLon,
  mergeFavoritesByContentId,
  reorderHomepageFavorites,
  sortFavoritesForStableDisplay,
} from '../../util/favoriteApi.util';
import { hasEpnGeometry, resolveRecordEpnGeometry, resolveRecordLocation } from '../../util/entityLocation.util';
import {
  completeHomepagePendingToast,
  dismissFacilityLocationPendingToast,
  dismissHomepagePendingToast,
  showFacilityLocationPendingToast,
  showHomepageErrorToast,
  showHomepagePendingToast,
} from '../../util/homepageFacilityToast.util';
import {
  ADD_TO_HOMEPAGE_TOOLTIP,
  formatHomepageSelectedCount,
  HOMEPAGE_DRAG_REORDER_HINT,
  HOMEPAGE_EMPTY_SLOT_HINT,
  HOMEPAGE_INSTRUCTIONS,
  HOMEPAGE_PANEL_HINT,
  HOMEPAGE_SLOT_LABELS,
  homepageSectionTitle,
  MANAGE_FACILITIES_ARIA_LABEL,
  MANAGE_FACILITIES_TITLE,
  MANAGE_FACILITIES_TOOLTIP_HELPER,
  MY_FACILITIES_INSTRUCTION,
  REMOVE_FROM_HOMEPAGE_TOOLTIP,
  REMOVE_SAVED_FACILITY_TOOLTIP,
  DELETE_FACILITY_CONFIRM_TITLE,
  DELETE_FACILITY_CONFIRM_CANCEL,
  DELETE_FACILITY_CONFIRM_ACTION,
  formatDeleteFacilityConfirmBody,
  SHOWN_ON_HOMEPAGE_BADGE,
  ALL_FACILITIES_SECTION,
} from '../../util/facilityHomepageCopy';
import {
  buildMyTundraPath,
  parseMyTundraSiteFromSearch,
  siteParamsKey,
} from '../../util/myTundraNavigation.util';
import { getStorage, ref, StorageReference } from 'firebase/storage';
import ReactGA from 'react-ga4';
import { commonColors, commonGreenButton, commonSoftGlassPanel } from '../ui/commonStyles';

interface IMyTundraContainer {
  showProgramQueryPanel: any;
  setShowProgramQueryPanel: any;
  programQueryEPNResult: any;
  boundingBox?: any;
  setBoundingBox?: any;
  showDocPanel: any;
  setShowDocPanel: any;
  showProgramQueryDocPanel: any;
  setShowProgramQueryDocPanel: any;
  activeMarkerRecord: any;
  setActiveMarkerRecord: any;
  onRectDrag?: any;
  doTextSearch: any;
  coords?: any;
  setProgramQueryEPNResult: any;
}

const MyTundraWrapper = styled.div `
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: #000;
`;

const ButtonContainer: any = styled.div`
  display: flex;
  padding: 5px 10px;
  background: ${commonColors.overlayBg};
  border: 1px solid ${commonColors.borderSoft};
  border-bottom: none;
  border-radius: 10px 10px 0 0;
  flex-direction: row-reverse;

  .btn,
  .btn-primary {
    ${commonGreenButton};
  }
`;

const ModalContainer: any = styled.div `
  width: 22%;
  top: 4.5rem;
  bottom: 9.5rem;
  height: auto;
  border-radius: 1rem;
  position: absolute;
  z-index: 1;
  color: #fff;
  border-left: hidden;
  left: 5%;
  // overflow-y: auto;
  padding: 0.5rem;
`;

const SearchContainer: any = styled.div `
  position: absolute;
  bottom: 75px;
  width: 100%;
  z-index: 1;

  .back-btn {
    min-width: 15%;
    border-radius: 50px;
    margin: 8px 48% 0;
    background-color: #5dc5c4 !important;
  }

  .search-box {
    width: 40%;
    margin: 0 35%;
    border: 2px solid #5DC5C4;
    border-radius: 10px;
    padding: 5px 10px;
    align-items: center;
    background-color: white;
    gap: 10px;

    .left-icon img {
      width: 55px;
    }
    .right-icon {
      width: 30px;
      margin: 0 auto;
    }
    input {
      border-width: 0;
      font-size: 20px;
      &:focus {
        border-width: 0 !important;
        box-shadow: unset;
      }
    }
  }

`;

const ButtonFav: any = styled.div`
  position: relative;
  /* flex-basis 0 keeps this from growing with list content when more facilities load */
  flex: 1 1 0;
  min-height: 0;
  overflow-y: scroll;
  padding-right: 6px;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: rgba(148, 163, 184, 0.65) rgba(148, 163, 184, 0.15);

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(148, 163, 184, 0.15);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(148, 163, 184, 0.55);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(148, 163, 184, 0.75);
  }
`;

const FavoritesSavingOverlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
`;

const FacilitiesPanelInstruction = styled.p`
  margin: 0;
  padding: 0 2px;
  font-size: 11px;
  line-height: 1.45;
  color: #94a3b8;
  flex-shrink: 0;
`;

const FacilitiesHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-shrink: 0;
`;

const FacilitiesTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;

  h2 {
    margin: 0;
  }
`;

const FacilitiesInfoButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-top: 3px;
  border: none;
  background: transparent;
  color: #94a3b8;
  cursor: help;
  flex-shrink: 0;

  &:hover,
  &:focus {
    color: #cbd5e1;
    outline: none;
  }

  .MuiSvgIcon-root {
    font-size: 18px;
  }
`;

const FacilitiesSavingIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  white-space: nowrap;

  .spinner-border {
    width: 0.85rem;
    height: 0.85rem;
    border-width: 0.12em;
  }
`;

const AddFacilityIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 8px;
  background: rgba(52, 211, 153, 0.15);
  color: #34d399;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: rgba(52, 211, 153, 0.28);
    border-color: rgba(52, 211, 153, 0.45);
  }

  .MuiSvgIcon-root {
    font-size: 20px;
  }
`;

const FacilitiesHeaderActions = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`;

const FavoritesContainer = styled(ModalContainer)`
  width: 30%;
  /* Explicit height so flex children can fill the panel on large screens. */
  top: 4.5rem;
  bottom: 5rem;
  height: calc(100vh - 4.5rem - 5rem);
  background: rgba(10, 10, 12, 0.62);
  border: 1px solid rgba(148, 163, 184, 0.28);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(8px);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow: hidden;
  min-height: 0;

  h2 {
    font-weight: 700;
    color: #94a3b8;
  }

  .no-favorites {
    text-align: center;
    padding: 1.5rem 0.5rem;
    color: #94a3b8;
    font-size: 13px;
  }
`;

const HomepageSection = styled.div<{ $compact?: boolean }>`
  /* Absorbs panel height changes; sizes to slots when instruction chrome is hidden. */
  flex: ${(props) => (props.$compact ? '0 0 auto' : '1 1 0')};
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(148, 163, 184, 0.22);
  scrollbar-width: thin;
  scrollbar-color: rgba(148, 163, 184, 0.55) transparent;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(148, 163, 184, 0.45);
    border-radius: 999px;
  }
`;

const HomepageSectionTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

const SectionSubheading = styled.h3`
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #cbd5e1;
  letter-spacing: 0.02em;
`;

const HomepageCountBadge = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: #34d399;
  white-space: nowrap;
`;

const HomepageSectionHint = styled.p`
  margin: 0;
  font-size: 11px;
  line-height: 1.4;
  color: #64748b;
`;

const HomepageSlotBlock = styled.div`
  margin: 0;
  & + & {
    margin-top: 0.015rem;
  }
`;

const HomepageSlotLabel = styled.span`
  display: block;
  margin-bottom: 6px;
  padding: 0 4px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.03em;
  line-height: 1.2;
  text-transform: uppercase;
  color: #64748b;
`;

const HomepageSectionLoader = styled(FavoritesSavingOverlay)`
  min-height: 72px;
`;

const HomepageSlotEmpty = styled.div`
  margin: 0;
  padding: 8px 10px;
  border: 1px dashed rgba(148, 163, 184, 0.35);
  border-radius: 999px;
  color: #64748b;
  font-size: 11px;
  text-align: center;
`;

const FacilityRowInner = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const HomepageStatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 999px;
  border: 1px solid rgba(52, 211, 153, 0.35);
  background: rgba(6, 78, 59, 0.2);
  color: #34d399;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
`;

const SlotActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 8px;
  background: rgba(10, 10, 12, 0.62);
  color: #94a3b8;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:hover {
    background: rgba(30, 41, 59, 0.55);
    border-color: rgba(148, 163, 184, 0.5);
    color: #cbd5e1;
  }

  .MuiSvgIcon-root {
    font-size: 16px;
  }
`;

const DeleteRowActionButton = styled(SlotActionButton)`
  border-color: rgba(248, 113, 113, 0.35);
  color: #f87171;

  &:hover {
    background: rgba(127, 29, 29, 0.35);
    border-color: rgba(248, 113, 113, 0.45);
    color: #fca5a5;
  }
`;

const FacilityRowActions = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

const AllFacilitiesSection = styled.div<{ $compact?: boolean }>`
  /* Fixed panel share; takes remaining space when homepage chrome is compact. */
  flex: ${(props) => (props.$compact ? '1 1 0' : '0 0 55%')};
  min-height: ${(props) => (props.$compact ? '0' : '220px')};
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  overflow: hidden;
`;

const AllFacilitiesLoader = styled(FavoritesSavingOverlay)`
  flex: 1 1 0;
  min-height: 0;
`;

const AllFacilitiesHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-shrink: 0;
`;

const AllFacilitiesCount = styled.span`
  font-size: 11px;
  color: #64748b;
`;

const AllFacilitiesLoadingMore = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 4px;
  font-size: 11px;
  color: #64748b;
`;

const AllFacilitiesLoadMoreButton = styled.button`
  display: block;
  width: 100%;
  margin: 4px 0 8px;
  padding: 8px 10px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 8px;
  background: rgba(15, 23, 42, 0.55);
  color: #94a3b8;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:hover:not(:disabled) {
    background: rgba(30, 41, 59, 0.7);
    border-color: rgba(148, 163, 184, 0.5);
    color: #cbd5e1;
  }

  &:disabled {
    opacity: 0.65;
    cursor: wait;
  }
`;

const OptionPanel: any = styled.div `
  overflow: auto;
  min-width: 34rem;
  max-width: 35rem;
  margin-left: 1rem;
  border-radius: 10px;
  ${commonSoftGlassPanel};
  color: ${commonColors.textPrimary};

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(15, 23, 42, 0.6);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #6c757d;
    border-radius: 20px;
  }
`;

const FavoritesButton: any = styled.button`
  border-radius: 999px;
  margin: 0;
  border: 1px solid rgba(148, 163, 184, 0.35);
  color: #94a3b8;
  background: rgba(10, 10, 12, 0.62);
  width: 100%;
  padding: 6px 10px;
  font-weight: 500;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  pointer-events: none;

  &:hover {
    background: rgba(30, 41, 59, 0.55);
    border-color: rgba(148, 163, 184, 0.5);
    color: #cbd5e1;
  }
`;

const FavoriteListItem = styled.div<{
  $isDragging?: boolean;
  $isResolving?: boolean;
}>`
  display: block;
  margin: 0.5rem 0;
  opacity: ${({ $isDragging, $isResolving }) => {
    if ($isResolving) return 0.65;
    if ($isDragging) return 0.75;
    return 1;
  }};
  cursor: ${({ $isDragging, $isResolving }) => {
    if ($isResolving) return 'wait';
    if ($isDragging) return 'grabbing';
    return 'grab';
  }};
  user-select: none;
  touch-action: none;
  transition: opacity 0.25s ease, margin 0.3s ease, transform 0.3s ease;
  pointer-events: ${({ $isResolving }) => ($isResolving ? 'none' : 'auto')};
`;

const FacilityNameButton = styled(FavoritesButton)<{ $canDrag?: boolean }>`
  flex: 1;
  min-width: 0;
  pointer-events: auto;
  cursor: ${({ $canDrag }) => ($canDrag ? 'inherit' : 'pointer')};
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const HomepageSlotRow = styled(FavoriteListItem)<{ $canDrag?: boolean }>`
  margin: 0;
  cursor: ${({ $canDrag, $isDragging }) => {
    if (!$canDrag) return 'default';
    return $isDragging ? 'grabbing' : 'grab';
  }};
`;

const AllFacilityListItem = styled(FavoriteListItem)`
  margin: 0.35rem 0;
  cursor: ${({ $isResolving }) => ($isResolving ? 'wait' : 'pointer')};
`;

const FacilityRowSpinnerWrap = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;

  .spinner-border {
    width: 0.85rem;
    height: 0.85rem;
    border-width: 0.12em;
  }
`;

const RecordDetailsContainer = styled.div `
  top: 4.5rem;
  bottom: 9.5rem;
  height: auto;
  width: fit-content;
  position: absolute;
  z-index: 1;
  left: 5%;
  display: flex;

  .iframe-container {
    margin-left: 1rem;
    position: relative;
    border-radius: 1.1rem;
    border: 1px solid rgba(148, 163, 184, 0.28);
    background: linear-gradient(160deg, rgba(8, 13, 20, 0.78) 0%, rgba(5, 10, 18, 0.74) 100%);
    box-shadow: 0 16px 36px rgba(0, 0, 0, 0.42);
    backdrop-filter: blur(14px);
    overflow: hidden;

    .max-btn {
      cursor: pointer;
      position: absolute;
      top: 0.45rem;
      right: 3rem;
      color: #34d399;
      border: 1px solid rgba(52, 211, 153, 0.45);
      background: rgba(2, 6, 23, 0.75);
      border-radius: 999px;
      width: 2rem;
      height: 2rem;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .close-iframe {
      position: absolute;
      top: 0.45rem;
      right: 0.7rem;
      color: #f8fafc;
      border: 1px solid rgba(148, 163, 184, 0.45);
      background: rgba(2, 6, 23, 0.75);
      border-radius: 999px;
      width: 2rem;
      height: 2rem;
      font-size: 1.1rem;
      line-height: 1;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    &__expanded {
      position: fixed;
      top: 0% !important;
      right: 4%;
      height: 90vh !important;
      width: 72vw !important;

      iframe {
        width: 100% !important;
      }
    }

    iframe {
      position: relative;
      z-index: 1;
      border: none;
      border-radius: 0.95rem;
      margin-top: 2.7rem;
      height: calc(100% - 2.7rem) !important;
      background: transparent;
    }

    .iframe-white-text {
      /* Force light text/dark paper for third-party iframe pages */
      filter: invert(1) hue-rotate(180deg) contrast(1.9) brightness(1.5) saturate(1.15) !important;
    }

    .iframe-native-dark {
      filter: none !important;
      background: #ffffff;
    }

    .iframe-tint-overlay {
      position: absolute;
      top: 2.7rem;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
      pointer-events: none;
      border-radius: 0.95rem;
      background: linear-gradient(180deg, rgba(2, 6, 23, 0.26) 0%, rgba(2, 6, 23, 0.12) 45%, rgba(2, 6, 23, 0.22) 100%);
      box-shadow: inset 0 0 0 1px rgba(148, 163, 184, 0.16), inset 0 20px 50px rgba(2, 6, 23, 0.25);
    }
  }
`;

const MyTundraMapContainer = styled.div `
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: #000;
`;

const SpinnerContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 25vh;
`;

const DocPreviewPanel = styled(OptionPanel) `
  max-width: 23rem;
  min-width: unset;
  height: 60vh;
  overflow: unset;
  position: relative;
  border-radius: 1rem;
  background: rgba(10, 10, 12, 0.72);
  border: 1px solid rgba(148, 163, 184, 0.28);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(10px);

  .MuiButton-root {
    min-width: unset;
    margin-left: 1rem;
    padding: 0.5rem;
  }

  .MuiSvgIcon-root {
    cursor: pointer;
  }
`;

const DocPreviewContainer = styled.div `
  padding: 5px 10px;
  background-color: transparent;
  color: #f8fafc;
  height: calc(56vh - 20px);
  overflow: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(15, 23, 42, 0.6);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #6c757d;
    border-radius: 20px;
  }
`;

const ContentTD = styled.p`
  && {
    padding: 0.75em;
    color: #f8fafc;
  }
  em {
    font-style: normal;
    font-weight: 700;
    color: #ffffff;
  }
`;

const PopoverContainer = styled.div`
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: linear-gradient(160deg, rgba(8, 13, 20, 0.78) 0%, rgba(5, 10, 18, 0.74) 100%);
  border-radius: 10px;
  padding: 10px;
  font-size: 12px;
  color: #f8fafc;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(10px);

  .table {
    color: #f8fafc;
    background: transparent;
  }

  .table td,
  .table th,
  .table thead th {
    color: #f8fafc;
    background: rgba(15, 23, 42, 0.45);
    border-color: rgba(148, 163, 184, 0.22);
  }

  .spinner-border {
    margin-top: -50%;
  }
`;

const NewsHeader = styled.h4`
  background: rgba(52, 211, 153, 0.2);
  border: 1px solid rgba(52, 211, 153, 0.4);
  padding: 10px 15px 12px;
  color: #f8fafc;
  text-align: center;
  border-radius: 10px;
  a {
    color: #f8fafc;
    text-decoration: underline;
  }
`;

const EmissionTR = styled.tr`
  background-color: #8080805e;
  color: #f8fafc;
  font-weight: 600;
`;

const CenterTD = styled.td`
  vertical-align: middle !important;
  text-align: center;
`;

const FixedTD = styled.td`
  width: 8em;
`;

const NavButtonsWrapper = styled.div`
  position: absolute;
  right: 0.5rem;
  bottom: 1rem
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

/** Hide instruction text only when browser page zoom is above 100%. */
const getBrowserZoomPercent = (): number => {
  if (typeof window === 'undefined') {
    return 100;
  }

  const dpr = window.devicePixelRatio || 1;
  // OS display scaling + browser zoom are combined in devicePixelRatio.
  // Infer browser zoom by matching against common OS scale × Chrome zoom steps.
  // When multiple pairs fit equally well (e.g. OS 125% @ 100% zoom vs OS 100% @ 125%),
  // prefer the interpretation closest to 100% browser zoom.
  const osScales = [1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 3];
  const chromeZooms = [25, 33, 50, 67, 75, 80, 90, 100, 110, 125, 150, 175, 200, 250, 300];
  let bestZoom = 100;
  let bestDiff = Number.POSITIVE_INFINITY;
  let bestDistanceFrom100 = Number.POSITIVE_INFINITY;

  osScales.forEach((scale) => {
    const zoomGuess = (dpr / scale) * 100;
    chromeZooms.forEach((zoomStep) => {
      const diff = Math.abs(zoomGuess - zoomStep);
      const distanceFrom100 = Math.abs(zoomStep - 100);
      const isCloserMatch = diff < bestDiff - 0.001;
      const isTieCloserTo100 =
        Math.abs(diff - bestDiff) <= 0.001 && distanceFrom100 < bestDistanceFrom100;
      if (isCloserMatch || isTieCloserTo100) {
        bestDiff = diff;
        bestZoom = zoomStep;
        bestDistanceFrom100 = distanceFrom100;
      }
    });
  });

  return bestZoom;
};

const MyTundraContainer: React.FC<IMyTundraContainer & {
  context: IAuthContext;
}> = (props) => {
  const context = props.context;
  const dispatch = useDispatch();
  const [showNavigation, setShowNavigation] = useState<boolean>(false);
  const [myFavList, setMyFavList] = useState<any[]>([]);
  const [draggedFavoriteContentId, setDraggedFavoriteContentId] = useState<string | null>(null);
  const [isSavingFavoriteOrder, setIsSavingFavoriteOrder] = useState(false);
  const myFavListRef = useRef<any[]>([]);
  const favoriteDidDragRef = useRef(false);
  const draggedFavoriteContentIdRef = useRef<string | null>(null);
  const homepageDropSlotRef = useRef<number | null>(null);
  const isSavingFavoriteOrderRef = useRef(false);
  const favoriteDragFinalizeRef = useRef(false);
  const favoriteOrderAtDragStartRef = useRef<string[] | null>(null);
  const favoriteOrderSavePromiseRef = useRef<Promise<void> | null>(null);
  const [gMap, setGMap] = useState<any>();
  const [gMaps, setGMaps] = useState<any>();
  // eslint-disable-next-line
  const [setStreetLocation] = useState<any>();
  const [rectangle, setRectangle] = useState<any>();
  const [relatedDocument, setRelatedDocument] = useState<ISearchRecord | null>(null);
  const [zoomLevel, setZoomLevel] = useState<any>();
  // eslint-disable-next-line
  const [mapFindingAutoScroll, setMapFindingAutoScroll] = useState<boolean>(false);
  const store: any = useSelector<any>((state): any => state);
  const mapState: IMap = store.map;
  const [showRecordOptions, setShowRecordOptions] = useState<boolean>(false);
  const [showAddFacilityModal, setShowAddFacilityModal] = useState<boolean>(false);
  const [addFacilityModalTab, setAddFacilityModalTab] = useState<
    'search-facilities' | 'saved-facilities'
  >('search-facilities');
  const [facilityPendingDelete, setFacilityPendingDelete] = useState<ISearchRecord | null>(null);
  const [isDeletingFacility, setIsDeletingFacility] = useState(false);
  const [downloadTriggers, setDownloadTriggers] = useState<string[]>([]);
  const [iFrameUrl, setIframeUrl] = useState<string>('');
  const [iFrameExpanded, setIFrameExpanded] = useState<boolean>();
  const [favButtons, setFavButtons] = useState<any[]>([]);
  // eslint-disable-next-line
  const [optionsList, setOptionsList] = useState<any>([{
    buttonId: 1,
    name: 'Permits',
    type: 'modal',
    isDefault: true,
  }, {
    buttonId: 2,
    name: 'Agency Documents',
    type: 'modal',
    isDefault: true,
  }, {
    buttonId: 3,
    name: 'Emission Events',
    type: 'modal',
    isDefault: true,
  }, {
    buttonId: 4,
    name: 'Deviations',
    type: 'modal',
    isDefault: true,
  }]);
  const [selectedRecord, setSelectedRecord] = useState<any>('');
  const [selectedRecordOption, setSelectedRecordOption] = useState<string>('');
  const [dischargeFacilityLocation, setDischargeFacilityLocation] = useState<{ lat: number; lon: number } | null>(null);
  const [dischargeOutfalls, setDischargeOutfalls] = useState<{ lat: number; lon: number }[]>([]);
  const [isWaterMode, setIsWaterMode] = useState<boolean>(false);
  // Water Wells + Monitor Wells for the selected facility, shown as map pins in
  // Water mode. Kept in local state (not shared jobState.esaData) so Land mode is
  // untouched.
  const [waterModeWells, setWaterModeWells] = useState<{
    water_wells: any;
    environmental_related_wells: any;
  } | null>(null);
  const [currentSearchTerm, setCurrentSearchTerm] = useState<string>('');
  const [favoritesIsLoading, setFavoritesIsLoading] = useState<boolean>(false);
  const [favoritesIsLoadingMore, setFavoritesIsLoadingMore] = useState<boolean>(false);
  const [totalFavoriteCount, setTotalFavoriteCount] = useState(0);
  const favoritesFullyLoadedRef = useRef(false);
  const favoritesLoadInFlightRef = useRef(false);
  const favoritesBootstrapStartedRef = useRef(false);
  const totalFavoriteCountRef = useRef(0);
  const favoritesListRef = useRef<HTMLDivElement | null>(null);
  const [isFacilitiesPanelCompact, setIsFacilitiesPanelCompact] = useState(
    () => getBrowserZoomPercent() > 100
  );

  useEffect(() => {
    const updateCompactFromZoom = () => {
      setIsFacilitiesPanelCompact(getBrowserZoomPercent() > 100);
    };

    updateCompactFromZoom();
    window.addEventListener('resize', updateCompactFromZoom);
    window.visualViewport?.addEventListener('resize', updateCompactFromZoom);
    window.visualViewport?.addEventListener('scroll', updateCompactFromZoom);

    return () => {
      window.removeEventListener('resize', updateCompactFromZoom);
      window.visualViewport?.removeEventListener('resize', updateCompactFromZoom);
      window.visualViewport?.removeEventListener('scroll', updateCompactFromZoom);
    };
  }, []);
  const [showCustomizeButtons, setShowCustomizeButtons] = useState<boolean>(false);
  const [airEmissions, setAirEmissions] = useState<any>({});
  const [airEmissionsLoading, setAirEmissionsLoading] = useState<any>(false);
  const [airQualityLoading, setAirQualityLoading] = useState<any>(false);
  const [airQualityIndex, setAirQualityIndex] = useState<any>();
  // eslint-disable-next-line
  const [relatedRecordIndex, setRelatedRecordIndex] = useState<number>(0);
  const [complianceData, setComplianceData] = useState<any>({});
  const [mapType, setMapType] = useState<any>();
  const [selectedButton, setSelectedButton] = useState<string | undefined>();
  const [firstZoom, setFirstZoom] = useState<boolean>(true);
  const pendingFavoriteAppliedRef = useRef(false);
  const facilityNavigationInFlightRef = useRef(false);
  const [resolvingFacilityContentId, setResolvingFacilityContentId] = useState<string | null>(null);
  const appliedSiteKeyRef = useRef<string | null>(null);
  const jobState: IJob = store.job;
  const aiEarthState: IAIEarth = store.aiearth;
  const [copySnackbar, setCopySnackbar] = useState(false);
  const [IframeSpinner, setIframeSpinner] = useState<boolean>(true);
  const history = useHistory();
  const location = useLocation();
  const isBackButton = !!store.globalFlags.previousPage && store.globalFlags.previousPage === 'myenviroaiToFacility';

  const syncSiteToUrl = (record: ISearchRecord) => {
    const path = buildMyTundraPath({
      contentId: record.contentId,
      entityNumber: record.entityNumber,
    });
    if (path !== `${location.pathname}${location.search}`) {
      history.replace(path);
    }
  };

  const clearActiveFacility = useCallback(() => {
    setShowRecordOptions(false);
    setSelectedRecordOption('');
    setMapType('');
    const clearPath = buildMyTundraPath();
    if (`${location.pathname}${location.search}` !== clearPath) {
      history.replace(clearPath);
    }
  }, [history, location.pathname, location.search]);

  const hideIframeSpinner = () => {
    setIframeSpinner(false);
  };
  const handleClose = () => {
    setCopySnackbar(false);
  };

  const AlertMessage = ({ text, severity, onClose }: { text: string; severity: any; onClose: () => void }) => (
    <MuiAlert elevation={6} variant="filled" severity={severity} onClose={onClose}>
      {text}
    </MuiAlert>
  );

  const handleCopyToClipboard = async () => {
    try {
      // Test permission state
      await (navigator as any).permissions.query({ name: 'clipboard-write' as any });
      try {
        if(iFrameUrl.includes('ejscreen.epa.gov/mapper/')||iFrameUrl.includes('onemap.cdc.gov/portal/apps/sites/#/eji-explorer')) {
          await navigator.clipboard.writeText(selectedRecord.physicalAddress);
        }
      } catch (clipboardError) {
        toast.warn('Clipboard is blocked, despite permission state.');
      }
    } catch (error) {
      toast.warn('Unable to check clipboard permissions.');
    }
  };

  useEffect(() => {
    if(copySnackbar) {
      handleCopyToClipboard();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [copySnackbar]);

  const isValidLatLong = (lat: number, lng: number) => isValidLatLon(lat, lng);

  const getUserFavButtons = async ()=> {
    try {
      const resp = await buttonFavorite({
        actionType: 'getAll',
      });
      if(resp.data && resp.data.length) {
        const existingButtons = resp.data.map((elem: any) => {
          if(elem.buttonId === 5 && !elem.href.includes('/search')) {
            elem.href += '/search';
          }
          return elem;
        });
        const optList = [...optionsList, ...existingButtons];
        setOptionsList(optList);
        setFavButtons(optList);
      }
    } catch (error) {
      toast.error(`Error while fetching favorite button list.`);
    }
  };

  useEffect(() => {
    getUserFavButtons();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const plotLatLong = (data: any) => {
    const epnArray: any[] = [];
    data.map((ele: any) => {
      if (ele.location.geomz) {
        const decryptedData = CryptoJS.AES.decrypt(ele.location.geomz, secKey, {
          iv,
          mode: CryptoJS.mode.CBC,
        }).toString(CryptoJS.enc.Utf8);
        const latLon = decryptedData.split(',');
        ele.location.lon = parseFloat(latLon[0]);
        ele.location.lat = parseFloat(latLon[1]);
      }
      if (ele.location.geom_json) {
        for (const epnKey in ele.location.geom_json) {
          if (ele.location.geom_json.hasOwnProperty(epnKey)) {
            for (const epnInnerKey in ele.location.geom_json[epnKey]) {
              if (ele.location.geom_json[epnKey].hasOwnProperty(epnInnerKey)) {
                const element = ele.location.geom_json[epnKey][epnInnerKey];
                const epnRecord: any = {};
                if (element.geom) {
                  const decryptedData = CryptoJS.AES.decrypt(element.geom, secKey, {
                    iv,
                    mode: CryptoJS.mode.CBC,
                  }).toString(CryptoJS.enc.Utf8);
                  const latLon = decryptedData.split(',');
                  epnRecord.location = Object.assign({});
                  epnRecord.location.lon = parseFloat(latLon[0]);
                  epnRecord.location.lat = parseFloat(latLon[1]);
                  epnRecord.marker = element.marker;
                  epnRecord.name = element.name;
                  epnRecord.type = element.type;
                  epnRecord.details = element.details;
                  if (ele.entityNumber) {
                    epnRecord.entityNumber = ele.entityNumber;
                    epnArray.push(epnRecord);
                  }
                }
              }
            }
          }
        }
      }
      return ele;
    });
    props.setProgramQueryEPNResult(epnArray);
  };

  const onNavigationItemClickHandle = async (searchRecord: any, e: any, pass: boolean = false) => {
    const facilityKey = searchRecord.contentId || searchRecord.entityNumber || '';
    if (facilityNavigationInFlightRef.current) {
      return;
    }

    if (mapType === 'jobs') {
      setMapType('');
      resetJobMap();
    }

    setIframeUrl('');

    if (searchRecord.entityName === selectedRecord.entityName && !pass) {
      setSelectedRecord(searchRecord);
      setShowRecordOptions(true);
      return;
    }

    if (!pass && (searchRecord.searchTerm && currentSearchTerm !== searchRecord.searchTerm)) {
      setCurrentSearchTerm(searchRecord.searchTerm);
    }

    facilityNavigationInFlightRef.current = true;
    setResolvingFacilityContentId(facilityKey || null);
    showFacilityLocationPendingToast();

    // Immediate feedback — panel opens while location loads in the background.
    setSelectedRecord(searchRecord);
    setShowRecordOptions(true);
    props.setActiveMarkerRecord(searchRecord);
    props.setShowDocPanel(false);
    props.setShowProgramQueryPanel(false);

    ReactGA.event({
      category: 'Search',
      action: 'MyTundra Entity Search',
      label: searchRecord.entityNumber,
    });

    let enrichedRecord = searchRecord;
    try {
      if (!isValidLatLong(searchRecord.location?.lat, searchRecord.location?.lon)) {
        enrichedRecord = await resolveRecordLocation(searchRecord);
      }

      setSelectedRecord(enrichedRecord);
      props.setActiveMarkerRecord(enrichedRecord);
      if (enrichedRecord.contentId || enrichedRecord.entityNumber) {
        syncSiteToUrl(enrichedRecord);
        appliedSiteKeyRef.current = siteParamsKey({
          contentId: enrichedRecord.contentId,
          entityNumber: enrichedRecord.entityNumber,
        });
      }

      if (!isValidLatLong(enrichedRecord.location.lat, enrichedRecord.location.lon)) {
        dismissFacilityLocationPendingToast();
        toast.info(
          <span>
            AI Earth is not mapping this site because the original agency source data does not provide
            sufficient information for an accurate geocode.
          </span>,
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 10000,
          }
        );
        return;
      }

      panToSite(enrichedRecord.location.lat, enrichedRecord.location.lon);
      dismissFacilityLocationPendingToast();
      toast.info('Zoom in to show more information.');
      void plotEpnForRecord(enrichedRecord);
    } catch {
      dismissFacilityLocationPendingToast();
      toast.error('Could not load facility location. Please try again.');
    } finally {
      facilityNavigationInFlightRef.current = false;
      setResolvingFacilityContentId(null);
    }
  };

  const getCenterWithOffset = (lat: number, lng: number, offsetX: number, offsetY: number) => {
    if (!gMap || !gMaps) {
      return;
    }
    const currentMapProjection = gMap.getProjection();
    const point = currentMapProjection.fromLatLngToPoint(new gMaps.LatLng(lat, lng));
    // point.x = point.x + offsetX;
    // point.y = point.y + offsetY;
    const newCenterLatLng = currentMapProjection.fromPointToLatLng(point);
    return { lat: newCenterLatLng.lat(), lng: newCenterLatLng.lng() };
  };

  const panToSite = (lat: number, lon: number) => {
    if (!gMap || !gMaps) {
      return;
    }
    const tryPan = () => {
      const center = getCenterWithOffset(lat, lon, -0.1, -0.15);
      if (center) {
        gMap.panTo(center);
        gMap.setMapTypeId('satellite');
        setZoomLevel(16);
        return true;
      }
      return false;
    };
    if (tryPan()) {
      return;
    }
    const listener = gMap.addListener('idle', () => {
      if (tryPan() && window.google?.maps?.event) {
        window.google.maps.event.removeListener(listener);
      }
    });
  };

  const getRecordForEpnPlot = (record: ISearchRecord): ISearchRecord => {
    const fromList = myFavList.find(
      (item) =>
        (record.contentId && item.contentId === record.contentId) ||
        (record.entityNumber && item.entityNumber === record.entityNumber)
    );
    return fromList || record;
  };

  const plotEpnForRecord = async (record: ISearchRecord) => {
    const plotRecord = getRecordForEpnPlot(record);
    let withGeometry = plotRecord;
    if (!hasEpnGeometry(plotRecord)) {
      try {
        withGeometry = await resolveRecordEpnGeometry(plotRecord);
      } catch {
        withGeometry = plotRecord;
      }
    }
    if (hasEpnGeometry(withGeometry)) {
      plotLatLong([withGeometry]);
    } else {
      props.setProgramQueryEPNResult([]);
    }
  };

  const resolveFavoriteRecordLocation = async (
    record: ISearchRecord
  ): Promise<ISearchRecord> => {
    try {
      return await resolveRecordLocation(record);
    } catch {
      return record;
    }
  };

  const resolvePendingFavoriteRecord = async (
    pending: { contentId?: string; entityNumber?: string; record?: ISearchRecord }
  ): Promise<ISearchRecord | null> => {
    if (pending.record && (pending.record.contentId || pending.record.entityNumber)) {
      return resolveFavoriteRecordLocation(pending.record);
    }
    if (pending.contentId) {
      const byContentId = myFavList.find((item) => item.contentId === pending.contentId);
      if (byContentId) return resolveFavoriteRecordLocation(byContentId);
    }
    if (pending.entityNumber) {
      const byEntity = myFavList.filter((item) => item.entityNumber === pending.entityNumber);
      if (byEntity.length === 1) return resolveFavoriteRecordLocation(byEntity[0]);
    }
    return null;
  };

  const applyMyTundraPendingFavorite = useCallback(async () => {
    if (!gMap || !gMaps) {
      return false;
    }

    let pending: {
      contentId?: string;
      entityNumber?: string;
      record?: ISearchRecord;
    } | null = null;

    const raw = sessionStorage.getItem('myTundraPendingFavorite');
    if (raw) {
      try {
        pending = JSON.parse(raw);
      } catch {
        pending = null;
      }
      sessionStorage.removeItem('myTundraPendingFavorite');
    }

    if (!pending?.record && !pending?.contentId && !pending?.entityNumber) {
      pending = parseMyTundraSiteFromSearch(location.search);
    }

    if (!pending) {
      return false;
    }

    const key = siteParamsKey(pending);
    const match = await resolvePendingFavoriteRecord(pending);
    if (!match) {
      return false;
    }

    if (appliedSiteKeyRef.current === key && pendingFavoriteAppliedRef.current) {
      const epnCount = props.programQueryEPNResult?.length ?? 0;
      if (epnCount === 0) {
        await plotEpnForRecord(match);
      }
      return true;
    }

    pendingFavoriteAppliedRef.current = true;
    appliedSiteKeyRef.current = key;
    await onNavigationItemClickHandle(match, null, true);
    setFirstZoom(false);
    syncSiteToUrl(match);
    return true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gMap, gMaps, myFavList, location.search]);

  const zoomFirstFavorite = () => {
    if (!myFavList || myFavList.length === 0) {
      return;
    }

    const firstRecord = myFavList[0];
    // Only auto-zoom when cached coordinates are already valid — avoid a silent
    // multi-second wait on first paint while query_ceres_ed transfers large payloads.
    if (!isValidLatLon(firstRecord.location?.lat, firstRecord.location?.lon)) {
      return;
    }

    setSelectedRecord(firstRecord);
    props.setActiveMarkerRecord(firstRecord);
    props.setShowDocPanel(false);
    props.setShowProgramQueryPanel(false);
    panToSite(firstRecord.location.lat, firstRecord.location.lon);
    void plotEpnForRecord(firstRecord);
  };

  const getFilterInfo = (fetchData: any) => {
    let jsonArray: any = '';
    for (const val of fetchData) {
      if (val.properties.vec_all === true) {
        if (jsonArray) {
          jsonArray = jsonArray.concat([val]);
        } else {
          jsonArray = [val];
        }
      }
    }
    return jsonArray;
  };

  const setSubjectPropertyEsaData = (subjectPropertyData: any, type: string = 'astm') => {
    if (subjectPropertyData) {
      if (mapState.subjectPropertyShowLayer) {
        mapState.subjectPropertyShowLayer.forEach((feature: any) => {
          mapState.subjectPropertyShowLayer.remove(feature);
        });
      }
      if (mapState.adjoiningPropertyLayer) {
        mapState.adjoiningPropertyLayer.forEach((feature: any) => {
          mapState.adjoiningPropertyLayer.remove(feature);
        });
      }
      if (mapState.waterWellsPointer) {
        mapState.waterWellsPointer.forEach((feature: any) => {
          mapState.waterWellsPointer.remove(feature);
        });
      }
      if (mapState.monitorWellsPointer) {
        mapState.monitorWellsPointer.forEach((feature: any) => {
          mapState.monitorWellsPointer.remove(feature);
        });
      }
      if (mapState.soilsPropertyLayer) {
        mapState.soilsPropertyLayer.forEach((feature: any) => {
          mapState.soilsPropertyLayer.remove(feature);
        });
      }
      const getType = (subjectPropJson: any) => {
        if (subjectPropJson.type === 'Polygon') {
          return polygon(subjectPropJson.coordinates);
        } else if (subjectPropJson.type === 'MultiPolygon') {
          return multiPolygon(subjectPropJson.coordinates);
        } else if (subjectPropJson.type === 'MultiLineString') {
          return multiLineString(subjectPropJson.coordinates);
        }
      };
      if (
        subjectPropertyData.subject_property ||
        subjectPropertyData.one_mile_buffer ||
        subjectPropertyData.half_mile_buffer ||
        subjectPropertyData.quarter_mile_buffer ||
        subjectPropertyData.regulated_entities_boundaries ||
        subjectPropertyData.regulated_entities_point
      ) {
        let polygonObj: any = {};
        const oneMileBuffer = subjectPropertyData.one_mile_buffer;
        if (
          oneMileBuffer &&
          typeof oneMileBuffer.features !== 'undefined' &&
          Object.keys(oneMileBuffer.features).length > 0 &&
          type === 'astm'
        ) {
          mapState.subjectPropertyShowLayer.addGeoJson(subjectPropertyData.one_mile_buffer);
        }
        if (
          subjectPropertyData.half_mile_buffer &&
          typeof subjectPropertyData.half_mile_buffer.features !== 'undefined' &&
          Object.keys(subjectPropertyData.half_mile_buffer.features).length > 0 &&
          type === 'astm'
        ) {
          mapState.subjectPropertyShowLayer.addGeoJson(subjectPropertyData.half_mile_buffer);
        }
        if (
          subjectPropertyData.quarter_mile_buffer &&
          typeof subjectPropertyData.quarter_mile_buffer.features !== 'undefined' &&
          Object.keys(subjectPropertyData.quarter_mile_buffer.features).length > 0 &&
          (type === 'astm' || type === 'topos' || type === 'oilgas' || type === 'water' || type === 'monitor')
        ) {
          mapState.subjectPropertyShowLayer.addGeoJson(subjectPropertyData.quarter_mile_buffer);
        }
        if (
          subjectPropertyData.regulated_entities_boundaries &&
          typeof subjectPropertyData.regulated_entities_boundaries.features !== 'undefined' &&
          typeof subjectPropertyData.regulated_entities_boundaries.features[0].geometry !== 'undefined' &&
          Object.keys(subjectPropertyData.regulated_entities_boundaries.features).length > 0 &&
          type === 'astm'
        ) {
          mapState.subjectPropertyShowLayer.addGeoJson(subjectPropertyData.regulated_entities_boundaries);
        }
        if (
          subjectPropertyData.regulated_entities_boundaries &&
          typeof subjectPropertyData.regulated_entities_boundaries.features !== 'undefined' &&
          typeof subjectPropertyData.regulated_entities_boundaries.features[0].geometry !== 'undefined' &&
          Object.keys(subjectPropertyData.regulated_entities_boundaries.features).length > 0 &&
          type === 'vec'
        ) {
          const boundaryJson = getFilterInfo(subjectPropertyData.regulated_entities_boundaries.features);
          if (Object.keys(boundaryJson).length > 0) {
            const regulatedEntityBoundary = {
              type: 'FeatureCollection',
              features: boundaryJson,
            };
            mapState.subjectPropertyShowLayer.addGeoJson(regulatedEntityBoundary);
          }
        }
        if (
          subjectPropertyData.regulated_entities_point &&
          typeof subjectPropertyData.regulated_entities_point.features !== 'undefined' &&
          typeof subjectPropertyData.regulated_entities_point.features[0].geometry !== 'undefined' &&
          Object.keys(subjectPropertyData.regulated_entities_point.features).length > 0 &&
          type === 'astm'
        ) {
          mapState.subjectPropertyShowLayer.addGeoJson(subjectPropertyData.regulated_entities_point);
          markerJson(subjectPropertyData.regulated_entities_point.features);
          jobState.mapFindings = setMapFindings(subjectPropertyData.regulated_entities_point.features);
          jobState.toolTipPoint = markerJson(subjectPropertyData.regulated_entities_point.features);
          dispatch(updateJob(jobState));
        }
        if (
          subjectPropertyData.regulated_entities_point &&
          typeof subjectPropertyData.regulated_entities_point.features !== 'undefined' &&
          typeof subjectPropertyData.regulated_entities_point.features[0].geometry !== 'undefined' &&
          Object.keys(subjectPropertyData.regulated_entities_point.features).length > 0 &&
          type === 'vec'
        ) {
          const filterData = getFilterInfo(subjectPropertyData.regulated_entities_point.features);
          jobState.mapFindings = setMapFindings(filterData);
          jobState.toolTipPoint = markerJson(filterData);
          dispatch(updateJob(jobState));
          if (Object.keys(filterData).length > 0) {
            const regulatedEntityPoint = {
              type: 'FeatureCollection',
              features: filterData,
            };
            mapState.subjectPropertyShowLayer.addGeoJson(regulatedEntityPoint);
          }
        }
        if (
          subjectPropertyData.vec_entities_boundaries &&
          typeof subjectPropertyData.vec_entities_boundaries.features !== 'undefined' &&
          Object.keys(subjectPropertyData.vec_entities_boundaries.features).length > 0 &&
          type === 'vec'
        ) {
          mapState.subjectPropertyShowLayer.addGeoJson(subjectPropertyData.vec_entities_boundaries);
        }
        if (
          subjectPropertyData.vec_entities_point &&
          typeof subjectPropertyData.vec_entities_point.features !== 'undefined' &&
          Object.keys(subjectPropertyData.vec_entities_point.features).length > 0 &&
          type === 'vec'
        ) {
          mapState.subjectPropertyShowLayer.addGeoJson(subjectPropertyData.vec_entities_point);
        }
        if (
          subjectPropertyData.thirty_feet_buffer &&
          typeof subjectPropertyData.thirty_feet_buffer.features !== 'undefined' &&
          Object.keys(subjectPropertyData.thirty_feet_buffer.features).length > 0 &&
          type === 'vec'
        ) {
          mapState.subjectPropertyShowLayer.addGeoJson(subjectPropertyData.thirty_feet_buffer);
        }
        if (
          subjectPropertyData.vec_crossgradient_buffer &&
          typeof subjectPropertyData.vec_crossgradient_buffer.features !== 'undefined' &&
          Object.keys(subjectPropertyData.vec_crossgradient_buffer.features).length > 0 &&
          type === 'aerial'
        ) {
          mapState.subjectPropertyShowLayer.addGeoJson(subjectPropertyData.vec_crossgradient_buffer);
        }
        if (
          subjectPropertyData.vec_downgradient_buffer &&
          typeof subjectPropertyData.vec_downgradient_buffer.features !== 'undefined' &&
          Object.keys(subjectPropertyData.vec_downgradient_buffer.features).length > 0 &&
          type === 'vec'
        ) {
          mapState.subjectPropertyShowLayer.addGeoJson(subjectPropertyData.vec_downgradient_buffer);
        }
        if (
          subjectPropertyData.vec_upgradient_buffer &&
          typeof subjectPropertyData.vec_upgradient_buffer.features !== 'undefined' &&
          Object.keys(subjectPropertyData.vec_upgradient_buffer.features).length > 0 &&
          type === 'vec'
        ) {
          mapState.subjectPropertyShowLayer.addGeoJson(subjectPropertyData.vec_upgradient_buffer);
        }
        if (
          subjectPropertyData.vec_angel &&
          typeof subjectPropertyData.vec_angel.features !== 'undefined' &&
          Object.keys(subjectPropertyData.vec_angel.features).length > 0 &&
          type === 'vec'
        ) {
          mapState.subjectPropertyShowLayer.addGeoJson(subjectPropertyData.vec_angel);
        }
        if (
          subjectPropertyData.contours &&
          typeof subjectPropertyData.contours.features !== 'undefined' &&
          subjectPropertyData.contours.features !== null &&
          Object.keys(subjectPropertyData.contours.features).length > 0 &&
          type === 'vec'
        ) {
          mapState.subjectPropertyShowLayer.addGeoJson(subjectPropertyData.contours);
        }
        if (
          subjectPropertyData.oil_gas_pipe_lines &&
          subjectPropertyData.oil_gas_pipe_lines.features &&
          type === 'oilgas'
        ) {
          mapState.pipeLinesJobMaps.addGeoJson(subjectPropertyData.oil_gas_pipe_lines);
        }
        if (subjectPropertyData.oil_gas_points && subjectPropertyData.oil_gas_points.features && type === 'oilgas') {
          mapState.oilGasJobMaps.addGeoJson(subjectPropertyData.oil_gas_points);
        }
        if (
          subjectPropertyData.adjoining_properties_boundaries &&
          subjectPropertyData.adjoining_properties_boundaries.features &&
          Object.keys(subjectPropertyData.adjoining_properties_boundaries.features).length > 1 &&
          type === 'adjoin'
        ) {
          mapState.adjoiningPropertiesBoundaries.addGeoJson(subjectPropertyData.adjoining_properties_boundaries);
          dispatch(
            updateJob({
              ...jobState,
              ...{
                adjoiningPropertiesBoundaries: setMapFindings(
                  subjectPropertyData.adjoining_properties_boundaries.features
                ),
              },
            })
          );
        }
        if (
          subjectPropertyData.water_wells &&
          typeof subjectPropertyData.water_wells.features !== 'undefined' &&
          subjectPropertyData.water_wells.features !== null &&
          Object.keys(subjectPropertyData.water_wells.features).length > 0 &&
          type === 'water'
        ) {
          mapState.waterWellsPointer.addGeoJson(subjectPropertyData.water_wells);
        }
        if (
          subjectPropertyData.soils &&
          typeof subjectPropertyData.soils.features !== 'undefined' &&
          subjectPropertyData.soils.features !== null &&
          Object.keys(subjectPropertyData.soils.features).length > 0 &&
          type === 'soils'
        ) {
          mapState.soilsPropertyLayer.addGeoJson(subjectPropertyData.soils);
        }

        if (
          subjectPropertyData.environmental_related_wells &&
          typeof subjectPropertyData.environmental_related_wells.features !== 'undefined' &&
          subjectPropertyData.environmental_related_wells.features !== null &&
          Object.keys(subjectPropertyData.environmental_related_wells.features).length > 0 &&
          type === 'monitor'
        ) {
          mapState.monitorWellsPointer.addGeoJson(subjectPropertyData.environmental_related_wells);
        }
        const subProperty = subjectPropertyData.subject_property;
        if (
          subProperty &&
          (type === 'astm' ||
            type === 'vec' ||
            type === 'topos' ||
            type === 'aerial' ||
            type === 'oilgas' ||
            type === 'adjoin' ||
            type === 'water' ||
            type === 'soils' ||
            type === 'monitor')
        ) {
          polygonObj = getType(subProperty.features[0].geometry);
          mapState.subjectPropertyShowLayer.addGeoJson(subProperty);
        }
        const centroidObj = centroid(polygonObj).geometry;
        if (centroidObj) {
          const latlng = new gMaps.LatLng(centroidObj.coordinates[1], centroidObj.coordinates[0]);
          gMap.panTo(latlng);
          if (
            type === 'vec' ||
            type === 'oilgas' ||
            type === 'adjoin' ||
            type === 'water' ||
            type === 'monitor' ||
            type === 'soils'
          ) {
            gMap.setZoom(16);
          } else {
            gMap.setZoom(15);
          }
        }
      } else {
        gMap.setZoom(5);
      }
    }
  };

  const resetJobMap = () => {
    if (mapState.mapOverLay) {
      mapState.mapOverLay.setMap(null);
      mapState.mapOverLay = null;
    }
    mapState.layers = [];
    mapState.execute = false;
    mapState.jobLayers = [];
    if (gMap && typeof gMap !== 'undefined') {
      gMap.setZoom(16);
    }

    if (mapState.subjectPropertyShowLayer) {
      mapState.subjectPropertyShowLayer.forEach((feature: any) => {
        mapState.subjectPropertyShowLayer.remove(feature);
      });
    }
    if (mapState.adjoiningPropertyLayer) {
      mapState.adjoiningPropertyLayer.forEach((feature: any) => {
        mapState.adjoiningPropertyLayer.remove(feature);
      });
    }
    if (mapState.waterWellsPointer) {
      mapState.waterWellsPointer.forEach((feature: any) => {
        mapState.waterWellsPointer.remove(feature);
      });
    }
    if (mapState.monitorWellsPointer) {
      mapState.monitorWellsPointer.forEach((feature: any) => {
        mapState.monitorWellsPointer.remove(feature);
      });
    }
    if (mapState.soilsPropertyLayer) {
      mapState.soilsPropertyLayer.forEach((feature: any) => {
        mapState.soilsPropertyLayer.remove(feature);
      });
    }
    dispatch(resetJob());
    setZoomLevel(16);
    dispatch(resetAir());
    // when page redirect from myenviroai
    dispatch(resetAIEarth());
    props.setShowProgramQueryDocPanel(false);
  };

  const handleOverlayModeChange = (mode: 'air' | 'water' | 'land') => {
    setIsWaterMode(mode === 'water');
    if (mode === 'land') {
      setMapType('jobs');
      dispatch(
        updateJob({
          ...jobState,
          jobFeatureTab: false,
          mapFindingTab: false,
          jobFeature: {},
        })
      );
    } else {
      if (mapType === 'jobs') {
        setMapType(undefined);
        resetJobMap();
      }
      setSelectedButton(undefined);
      if (mode === 'water' && gMap) {
        if (dischargeFacilityLocation) {
          gMap.panTo({ lat: dischargeFacilityLocation.lat, lng: dischargeFacilityLocation.lon });
        } else {
          const record = selectedRecord?.location?.lat ? selectedRecord : props.activeMarkerRecord;
          if (record?.location?.lat && record?.location?.lon) {
            gMap.panTo({ lat: record.location.lat, lng: record.location.lon });
          }
        }
      }
    }
    if (gMap) {
      gMap.setMapTypeId('satellite');
    }
  };

  useEffect(() => {
    if (!isWaterMode || !gMap || dischargeOutfalls.length === 0) return;
    if (dischargeOutfalls.length === 1) {
      const [o] = dischargeOutfalls;
      gMap.panTo({ lat: o.lat, lng: o.lon });
      gMap.setZoom(16);
      return;
    }
    const LatLngBoundsCtor = window.google?.maps?.LatLngBounds;
    if (!LatLngBoundsCtor) return;
    const bounds = new LatLngBoundsCtor();
    dischargeOutfalls.forEach((o) => bounds.extend({ lat: o.lat, lng: o.lon }));
    gMap.fitBounds(bounds, 80);
  }, [isWaterMode, dischargeOutfalls, gMap]);

  // ─── Water mode wells: fetch Water Wells + Monitor Wells for the selected
  // facility. Separate from the Land-mode getEsaData effect (gated to
  // mapType === 'jobs'), so Land behavior and the shared jobState.esaData stay
  // untouched. Cleared when leaving Water mode or when no facility is selected.
  useEffect(() => {
    if (!isWaterMode) {
      setWaterModeWells(null);
      return;
    }
    const record = selectedRecord?.location?.lat ? selectedRecord : props.activeMarkerRecord;
    const entityNumber = record?.entityNumber;
    if (!entityNumber) {
      setWaterModeWells(null);
      return;
    }
    let cancelled = false;
    axios
      .get(`${process.env.REACT_APP_CERES_URL}/getEsaDataPhase1?v_rn_number=${entityNumber}`)
      .then((response) => {
        if (cancelled) return;
        const esadata = response?.data?.[0]?.esadata;
        if (esadata && Object.keys(esadata).length > 0) {
          setWaterModeWells({
            water_wells: esadata.water_wells ?? null,
            environmental_related_wells: esadata.environmental_related_wells ?? null,
          });
        } else {
          setWaterModeWells(null);
        }
      })
      .catch((err: any) => {
        if (cancelled) return;
        setWaterModeWells(null);
        CeresLogger.error(err);
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isWaterMode, selectedRecord, props.activeMarkerRecord]);

  // ─── Water mode wells: draw both well layers as pins only. No pan/zoom and no
  // quarter-mile buffer or subject-property polygon, so the discharge-outfall
  // view and OutfallMarkers stay intact.
  useEffect(() => {
    const waterPointer = mapState.waterWellsPointer;
    const monitorPointer = mapState.monitorWellsPointer;
    const clearPointers = () => {
      if (waterPointer) {
        waterPointer.forEach((feature: any) => waterPointer.remove(feature));
      }
      if (monitorPointer) {
        monitorPointer.forEach((feature: any) => monitorPointer.remove(feature));
      }
    };
    clearPointers();
    if (isWaterMode && gMap && waterModeWells) {
      const wells = waterModeWells.water_wells;
      if (waterPointer && wells?.features && Object.keys(wells.features).length > 0) {
        waterPointer.addGeoJson(wells);
      }
      const monitorWells = waterModeWells.environmental_related_wells;
      if (
        monitorPointer &&
        monitorWells?.features &&
        Object.keys(monitorWells.features).length > 0
      ) {
        monitorPointer.addGeoJson(monitorWells);
      }
    }
    return clearPointers;
  }, [isWaterMode, waterModeWells, gMap, mapState.waterWellsPointer, mapState.monitorWellsPointer]);

  const onMarkerClick = (searchRecord: ISearchRecord | null) => {
    if (R.isNil(searchRecord)) {
      // return; // resetMapToInitial(); //test
    }
    props.setActiveMarkerRecord(searchRecord);
    setZoomLevel(18);
  };

  const doStorageDownload = R.contains(R.__, ['tceq_novell']);

  const getStorageRef = R.cond<string, StorageReference | null>([
    [R.equals('tceq_novell'), R.always(ref(getStorage(ceresApp), `gs://${process.env.REACT_APP_STORAGE_BUCKET_NOVELL}` || ''))],
    [R.T, R.always(null)],
]);

  const getIframeQueryParams = () => {
    if(selectedRecordOption === 'Permits' || iFrameUrl.includes('TCEQDeadlineReminder') || iFrameUrl.includes('tceq.liputra.com/texas-caer.php') || iFrameUrl.includes('NRC')
    || iFrameUrl.includes('EnforcementActions')) {
      return `?v_rn_number=${selectedRecord.entityNumber}`;
    } else if(iFrameUrl.includes('/search?type=SOCIAL')) {
      return `&q=${selectedRecord.entityName}&directsearch=yes&hideSearchBar=true`;
    }
    return `?rn=${selectedRecord.entityNumber}`;
  };

  const iframeEligibility = () => {
    if(iFrameUrl.includes('?skipIFrame=true')) {
      let url = iFrameUrl.replace('?skipIFrame=true', '');
      if(url.includes('www2.tceq.texas.gov/oce/ch/index.cfm')) {
        if(!complianceData.error) {
          url += `?fuseaction=main.viewdetails&rid=${complianceData.re_id}`;
        }
      }
      window.open(url, '_blank');
      return false;
    }
    return true;
  };

  const noIframeSpinner = () => {
    if(iFrameUrl.includes('/trackbot') || iFrameUrl.includes('/benchmarking') || iFrameUrl.includes('/sentiment') || iFrameUrl.includes('/search') ||
    iFrameUrl.includes('/generator') || iFrameUrl.includes('/corrective-tracker')) {
      setIframeSpinner(false);
      return false;
    }
    return true;
  };

  const isNativeDarkIframe = (url: string) =>
    ['/corrective-tracker', '/benchmarking', '/trackbot', '/generator', '/search', '/sentiment'].some(
      (path) => url.includes(path)
    );
  const getAirEmissions = async (airQualityData: any) => {
    const requestBody: any = {};
    requestBody.RN = airQualityData.entityNumber;
    try {
      setAirEmissionsLoading(true);
      const airEmissionResponse = await axios.post(
        API_BASE_URL + '/api/airEmissionPopup',
        requestBody,
        {
          headers: API_AUTH_HEADERS,
        }
      );
      setAirEmissionsLoading(false);
      const airEmissionData = airEmissionResponse.data;
      setAirEmissions(airEmissionData[0].aai_emission_popup);
      if(!Object.keys(airEmissionData[0].aai_emission_popup).length) {
        toast.error(`No Emissions data for ${selectedRecord.entityNumber}`);
      }
    } catch (e) {
      setAirEmissionsLoading(false);
      CeresLogger.error(e);
    }
  };

  const getAQIData = async (airQualityData: any) => {
    const requestBody: any = {};
    requestBody.latitude = airQualityData.latitude;
    requestBody.longitude = airQualityData.longitude;
    requestBody.distance = 25;
    requestBody.date = '2020-09-24';
    requestBody.type = 'latLong';
    try {
      setAirQualityLoading(true);
      const aqiResponse = await axios.post(
        API_BASE_URL + '/api/getAirQualityIndex',
        requestBody,
        {
          headers: API_AUTH_HEADERS,
        }
      );
      setAirQualityLoading(false);
      const aqiResult = aqiResponse.data;
      setAirQualityIndex(aqiResult);

      if(!aqiResult.length) {
        toast.error(`No Air Quality data for ${selectedRecord.entityNumber}`);
      }
    } catch (e) {
      setAirQualityLoading(false);
      CeresLogger.error(e);
    }
  };

  const getAirEmissionsMemo = React.useCallback(() => getAirEmissions({
    entityNumber: selectedRecord.entityNumber,
    latitude: selectedRecord.location.lat,
    longitude: selectedRecord.location.lon,
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [selectedRecord]);

  const getAQIDataMemo = React.useCallback(() => getAQIData({
    entityNumber: selectedRecord.entityNumber,
    latitude: selectedRecord.location.lat,
    longitude: selectedRecord.location.lon,
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [selectedRecord]);

  useEffect(() => {
    if(!selectedRecord) {
      return;
    }
    if(selectedRecordOption === 'Emissions Profile') {
      getAirEmissionsMemo();
    } else if(selectedRecordOption === 'Current Air Quality Conditions') {
      getAQIDataMemo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRecord, selectedRecordOption]);

  const getRecordOptionModal = () => {
    switch(selectedRecordOption) {
      case 'Emissions Profile':
        return (
           <OptionPanel>
            <ButtonContainer>
              <Button
                style={{
                  padding: '5px',
                  backgroundColor: commonColors.accent,
                  borderColor: commonColors.accent,
                  color: commonColors.accentText
                }}
                onClick={() => {
                  setSelectedRecordOption('');
                }}
                size="sm"
              >
                <ChevronLeft />
              </Button>
            </ButtonContainer>
            <PopoverContainer>
              <NewsHeader>Emissions Profile</NewsHeader>
              {airEmissionsLoading ? <SpinnerContainer>
                  <Spinner
                    as="span"
                    variant="primary"
                    animation="border"
                    role="status"
                    aria-hidden="true"
                  />
                </SpinnerContainer> :
                <Table bordered>
                  <tbody>
                    {Object.entries(airEmissions).length ? (
                      <>
                        <EmissionTR>
                          <CenterTD>Current Emissions Level</CenterTD>
                          <td>
                            {airEmissions.current_hourly_emissions_criteria_pounds}{' '}
                            {airEmissions.current_hourly_emissions_criteria_pounds !== '-'
                              ? 'lbs/hr(criteria pollutants)'
                              : ''}
                          </td>
                          <FixedTD>
                            {airEmissions.current_emissions_rank !== '-' ? 'Rank #' : ''}
                            {airEmissions.current_emissions_rank}
                          </FixedTD>
                        </EmissionTR>
                        <EmissionTR>
                          <CenterTD rowSpan={2}>Annual Emissions</CenterTD>
                          <td>
                            {airEmissions.annual_emissions_criteria_rank !== '-' && (
                              <Link to={'/benchmarking?rn=' + selectedRecord.entityNumber + '&event=2'}>
                                {airEmissions.annual_emissions_criteria_rank}
                                {' tons (criteria pollutants)'}
                              </Link>
                            )}
                            {airEmissions.annual_emissions_criteria_rank === '-' && '-'}
                          </td>
                          <FixedTD>
                            {airEmissions.current_emissions_rank !== '-' ? 'Rank #' : ''}
                            {airEmissions.current_emissions_rank}
                          </FixedTD>
                        </EmissionTR>
                        <EmissionTR>
                          <td>
                            {airEmissions.annual_emissions_co2e_tons !== '-' && (
                              <Link to={'/benchmarking?rn=' + selectedRecord.entityNumber + '&event=2'}>
                                {airEmissions.annual_emissions_co2e_tons}
                                {' tons (coe2)'}
                              </Link>
                            )}
                            {airEmissions.annual_emissions_co2e_tons === '-' && '-'}
                          </td>
                          <FixedTD>
                            {airEmissions.annual_emissions_co2e_rank !== '-' ? 'Rank #' : ''}
                            {airEmissions.annual_emissions_co2e_rank}
                          </FixedTD>
                        </EmissionTR>
                        <EmissionTR>
                          <CenterTD>Unauthorized Emissions since 2004</CenterTD>
                          <td>
                            {airEmissions.unauthorized_emissions_tons !== '-' && (
                              <Link to={'/benchmarking?rn=' + selectedRecord.entityNumber + '&event=1'}>
                                {airEmissions.unauthorized_emissions_tons}
                                {' tons'}
                              </Link>
                            )}
                            {airEmissions.unauthorized_emissions_tons === '-' && '-'}
                          </td>
                          <FixedTD>
                            {airEmissions.unauthorized_emissions_rank !== '-' ? 'Rank #' : ''}
                            {airEmissions.unauthorized_emissions_rank}
                          </FixedTD>
                        </EmissionTR>
                        <EmissionTR>
                          <CenterTD>Uncontrolled / Undercontrolled Emissions (NOx and VOC)</CenterTD>
                          <td>
                            {airEmissions.uncontrolled_emissions_tons !== '-' && (
                              <Link to={'/generator?rn=' + selectedRecord.entityNumber}>
                                {airEmissions.uncontrolled_emissions_tons}
                                {' tons'}
                              </Link>
                            )}
                            {airEmissions.uncontrolled_emissions_tons === '-' && '-'}
                          </td>
                          <FixedTD>
                            {airEmissions.uncontrolled_emissions_rank !== '-' ? 'Rank #' : ''}
                            {airEmissions.uncontrolled_emissions_rank}
                          </FixedTD>
                        </EmissionTR>
                      </>
                    ) : <p>No Data available</p>}
                  </tbody>
                </Table>
                }
            </PopoverContainer>
          </OptionPanel>
      );
      case 'Current Air Quality Conditions':
        return (
          <OptionPanel>
            <ButtonContainer>
              <Button
                style={{
                  padding: '5px',
                  backgroundColor: commonColors.accent,
                  borderColor: commonColors.accent,
                  color: commonColors.accentText
                }}
                onClick={() => {
                  setSelectedRecordOption('');
                }}
                size="sm"
              >
                <ChevronLeft />
              </Button>
            </ButtonContainer>
            <PopoverContainer>
              <NewsHeader>
                <a
                  href={
                    airQualityIndex &&
                    'https://www.airnow.gov/?city=' +
                      airQualityIndex[0].ReportingArea +
                      '&state=' +
                      airQualityIndex[0].StateCode +
                      '&country=USA'
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ cursor: 'pointer' }}
                >
                  Today's Air Quality for this Facility
                </a>
              </NewsHeader>
              {airQualityLoading ? <SpinnerContainer>
                  <Spinner
                    as="span"
                    variant="primary"
                    animation="border"
                    role="status"
                    aria-hidden="true"
                  />
                </SpinnerContainer> :
              <Table bordered hover>
                <thead>
                  <tr>
                    <th>Parameter</th>
                    <th>AQI</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {airQualityIndex && (
                    <>
                      {airQualityIndex[0] && (
                        <tr>
                          <td>{airQualityIndex[0].ParameterName}</td>
                          <td>{airQualityIndex[0].AQI}</td>
                          <td>{airQualityIndex[0].Category.Name}</td>
                        </tr>
                      )}
                      {airQualityIndex[1] && (
                        <tr>
                          <td>{airQualityIndex[1].ParameterName}</td>
                          <td>{airQualityIndex[1].AQI}</td>
                          <td>{airQualityIndex[1].Category.Name}</td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </Table>
               }
            </PopoverContainer>
          </OptionPanel>
        );
      case 'News & Internet Info About the Site':
        return (
          <OptionPanel>
          <ButtonContainer>
            <Button
              style={{
                padding: '5px',
                backgroundColor: commonColors.accent,
                borderColor: commonColors.accent,
                color: commonColors.accentText
              }}
              onClick={() => {
                setSelectedRecordOption('');
              }}
              size="sm"
            >
              <ChevronLeft />
            </Button>
          </ButtonContainer>
          <PopoverContainer>
            <MyTundraTabResultsModal queryText={selectedRecord.entityName}/>
          </PopoverContainer>
        </OptionPanel>
        );
        default:
        return (
          <OptionPanel>
            <ButtonContainer>
              <Button
                style={{
                  padding: '5px',
                  backgroundColor: commonColors.accent,
                  borderColor: commonColors.accent,
                  color: commonColors.accentText
                }}
                onClick={() => {
                  setSelectedRecordOption('');
                }}
                size="sm"
              >
                <ChevronLeft />
              </Button>
            </ButtonContainer>
            <MyTundraRecordMarker
              setRelatedDocument={setRelatedDocument}
              currentQueryText={selectedRecord.searchTerm}
              onInfoWindowClose={() => onMarkerClick(null)}
              key={selectedRecord.contentId}
              onMarkerClick={() => onMarkerClick(selectedRecord)}
              lat={selectedRecord.location.lat}
              lng={selectedRecord.location.lon}
              isActive={true}
              record={selectedRecord}
              isMap={false}
              showDocPanel={props.showDocPanel}
              setShowDocPanel={props.setShowDocPanel}
              selectedRecordOption={selectedRecordOption}
              setIframeUrl={setIframeUrl}
              relatedRecordIndex={relatedRecordIndex}
            />
          </OptionPanel>
          );
    }
  };

  const resetFavoriteDragState = () => {
    draggedFavoriteContentIdRef.current = null;
    homepageDropSlotRef.current = null;
    setDraggedFavoriteContentId(null);
    document.body.classList.remove('my-tundra-favorite-dragging');
    window.setTimeout(() => {
      favoriteDidDragRef.current = false;
    }, 0);
  };

  const favoriteListsMatch = (left: ISearchRecord[], right: ISearchRecord[]) =>
    left.length === right.length
    && left.every((favorite, index) => favorite.contentId === right[index]?.contentId);

  const applyHomepageDropOnDragEnd = () => {
    const draggedId = draggedFavoriteContentIdRef.current;
    const targetSlot = homepageDropSlotRef.current;
    if (!draggedId || targetSlot == null) {
      return false;
    }

    const draggedFromIndex = myFavListRef.current.findIndex(
      (favorite) => favorite.contentId === draggedId
    );
    if (draggedFromIndex < 0 || draggedFromIndex >= HOMEPAGE_FACILITY_SLOT_COUNT) {
      return false;
    }

    const reordered = reorderHomepageFavorites(
      myFavListRef.current,
      draggedId,
      targetSlot
    );
    if (favoriteListsMatch(reordered, myFavListRef.current)) {
      return false;
    }

    favoriteDidDragRef.current = true;
    myFavListRef.current = reordered;
    setMyFavList(reordered);
    return true;
  };

  const persistFavoriteOrder = async (orderedList: ISearchRecord[]): Promise<boolean> => {
    isSavingFavoriteOrderRef.current = true;
    setIsSavingFavoriteOrder(true);
    try {
      await searchFavorite({
        type: 'update_order',
        record: { contentIds: orderedList.map((favorite) => favorite.contentId) },
      });
      dispatch(
        updateAIEarth({
          ...aiEarthState,
          favorites: orderedList,
          favoritesLoaded: true,
        })
      );
      return true;
    } catch (error) {
      CeresLogger.error(error as any);
      showHomepageErrorToast();
      void loadAllFavorites();
      return false;
    } finally {
      isSavingFavoriteOrderRef.current = false;
      setIsSavingFavoriteOrder(false);
    }
  };

  const finalizeFavoriteDrag = async (draggedId: string) => {
    if (favoriteDragFinalizeRef.current) {
      return;
    }

    favoriteDragFinalizeRef.current = true;
    resetFavoriteDragState();

    const orderedList = myFavListRef.current;
    const contentIds = orderedList.map((favorite) => favorite.contentId);
    const startOrder = favoriteOrderAtDragStartRef.current;
    favoriteOrderAtDragStartRef.current = null;
    const orderChanged =
      !startOrder || startOrder.length !== contentIds.length
        ? favoriteDidDragRef.current
        : startOrder.some((id, index) => id !== contentIds[index]);

    if (!orderChanged) {
      favoriteDragFinalizeRef.current = false;
      return;
    }

    const runSave = async () => {
      try {
        showHomepagePendingToast(HOMEPAGE_TOAST_SAVING_ORDER);
        const saved = await persistFavoriteOrder(orderedList);
        if (saved) {
          completeHomepagePendingToast(HOMEPAGE_TOAST_ORDER_UPDATED);
        } else {
          dismissHomepagePendingToast();
        }
      } finally {
        favoriteDragFinalizeRef.current = false;
      }
    };

    const previousSave = favoriteOrderSavePromiseRef.current;
    const savePromise = (async () => {
      if (previousSave) {
        await previousSave.catch(() => undefined);
      }
      await runSave();
    })();
    favoriteOrderSavePromiseRef.current = savePromise;
    await savePromise;
  };

  const finalizeFavoriteDragRef = useRef(finalizeFavoriteDrag);
  finalizeFavoriteDragRef.current = finalizeFavoriteDrag;

  const onFavoriteDragStart = (event: React.DragEvent, contentId: string) => {
    if (isSavingFavoriteOrderRef.current) {
      event.preventDefault();
      return;
    }

    favoriteDragFinalizeRef.current = false;
    favoriteDidDragRef.current = false;
    favoriteOrderAtDragStartRef.current = myFavListRef.current.map(
      (favorite) => favorite.contentId
    );
    draggedFavoriteContentIdRef.current = contentId;
    homepageDropSlotRef.current = null;
    setDraggedFavoriteContentId(contentId);
    document.body.classList.add('my-tundra-favorite-dragging');
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text/plain', contentId);

    const dragGhost = document.createElement('div');
    dragGhost.style.cssText =
      'position:fixed;top:-1000px;left:-1000px;width:1px;height:1px;opacity:0;pointer-events:none';
    document.body.appendChild(dragGhost);
    try {
      event.dataTransfer.setDragImage(dragGhost, 0, 0);
    } catch {
      // setDragImage is not supported in all environments
    }
    window.requestAnimationFrame(() => {
      dragGhost.remove();
    });
  };

  const setHomepageDropTarget = (slotIndex: number) => {
    homepageDropSlotRef.current = slotIndex;
  };

  const onHomepageSlotDragOver = (event: React.DragEvent, slotIndex: number) => {
    event.preventDefault();
    event.stopPropagation();
    event.dataTransfer.dropEffect = 'move';

    const draggedId = draggedFavoriteContentIdRef.current;
    if (!draggedId) {
      return;
    }

    const draggedFromIndex = myFavListRef.current.findIndex(
      (favorite) => favorite.contentId === draggedId
    );
    if (draggedFromIndex < 0 || draggedFromIndex >= HOMEPAGE_FACILITY_SLOT_COUNT) {
      return;
    }

    setHomepageDropTarget(slotIndex);
  };

  const onHomepageSlotDragLeave = (event: React.DragEvent, slotIndex: number) => {
    const relatedTarget = event.relatedTarget as Node | null;
    if (relatedTarget && event.currentTarget.contains(relatedTarget)) {
      return;
    }
    if (homepageDropSlotRef.current === slotIndex) {
      homepageDropSlotRef.current = null;
    }
  };

  const onHomepageSlotDrop = (event: React.DragEvent, slotIndex: number) => {
    event.preventDefault();
    event.stopPropagation();
    setHomepageDropTarget(slotIndex);
    const draggedId = draggedFavoriteContentIdRef.current;
    if (!draggedId) {
      return;
    }
    applyHomepageDropOnDragEnd();
    void finalizeFavoriteDrag(draggedId);
  };

  const onFavoriteDragEnd = (event: React.DragEvent) => {
    event.preventDefault();
    const draggedId = draggedFavoriteContentIdRef.current;
    if (!draggedId) {
      return;
    }
    applyHomepageDropOnDragEnd();
    window.requestAnimationFrame(() => {
      void finalizeFavoriteDrag(draggedId);
    });
  };

  const onFavoriteListDrop = (event: React.DragEvent) => {
    event.preventDefault();
    const draggedId = draggedFavoriteContentIdRef.current;
    if (!draggedId) {
      return;
    }
    applyHomepageDropOnDragEnd();
    void finalizeFavoriteDrag(draggedId);
  };

  const onFavoriteItemClick = (favorite: ISearchRecord, event: any) => {
    if (favoriteDidDragRef.current || facilityNavigationInFlightRef.current) {
      return;
    }
    void onNavigationItemClickHandle(favorite, event);
  };

  const homepageFavorites = myFavList.slice(0, HOMEPAGE_FACILITY_SLOT_COUNT);
  const homepageSelectedCount = homepageFavorites.length;
  const allFacilitiesDisplayList = useMemo(
    () => sortFavoritesForStableDisplay(myFavList),
    [myFavList]
  );
  const savedFacilityCount = totalFavoriteCount > 0 ? totalFavoriteCount : myFavList.length;
  const homepageIsLoading = favoritesIsLoading && myFavList.length === 0;
  const allFacilitiesInitialLoading = favoritesIsLoading && myFavList.length === 0;

  const renderFavoritesSpinner = () => (
    <Spinner
      as="span"
      variant="light"
      animation="border"
      role="status"
      aria-hidden="true"
    />
  );

  const canReorderHomepageSlots =
    homepageSelectedCount > 1 && !isSavingFavoriteOrder;

  const handlePromoteToHomepage = async (
    contentId: string,
    event?: React.MouseEvent<HTMLButtonElement>
  ): Promise<boolean> => {
    event?.stopPropagation();
    if (isSavingFavoriteOrderRef.current) {
      return false;
    }

    const reordered = promoteFavoriteToHomepage(myFavListRef.current, contentId);
    if (favoriteListsMatch(reordered, myFavListRef.current)) {
      return false;
    }

    myFavListRef.current = reordered;
    setMyFavList(reordered);
    return persistFavoriteOrder(reordered);
  };

  const handleDemoteFromHomepage = async (
    contentId: string,
    event?: React.MouseEvent<HTMLButtonElement>
  ): Promise<boolean> => {
    event?.stopPropagation();
    if (isSavingFavoriteOrderRef.current) {
      return false;
    }

    const reordered = demoteFavoriteFromHomepage(myFavListRef.current, contentId);
    if (favoriteListsMatch(reordered, myFavListRef.current)) {
      return false;
    }

    myFavListRef.current = reordered;
    setMyFavList(reordered);
    return persistFavoriteOrder(reordered);
  };

  const handleReorderHomepageSlot = async (
    draggedContentId: string,
    targetSlotIndex: number
  ): Promise<boolean> => {
    if (isSavingFavoriteOrderRef.current) {
      return false;
    }

    const reordered = reorderHomepageFavorites(
      myFavListRef.current,
      draggedContentId,
      targetSlotIndex
    );
    if (favoriteListsMatch(reordered, myFavListRef.current)) {
      return false;
    }

    myFavListRef.current = reordered;
    setMyFavList(reordered);
    return persistFavoriteOrder(reordered);
  };

  const getFacilityLabel = (favorite: ISearchRecord) =>
    favorite.displayName || favorite.entityName || favorite.entityNumber;

  const isResolvingFavorite = (favorite: ISearchRecord) => {
    if (!resolvingFacilityContentId) {
      return false;
    }
    const facilityKey = favorite.contentId || favorite.entityNumber;
    return facilityKey === resolvingFacilityContentId;
  };

  const renderHomepageSlot = (slotIndex: number) => {
    const favorite = homepageFavorites[slotIndex];
    const { slot, role } = HOMEPAGE_SLOT_LABELS[slotIndex];

    if (!favorite) {
      return (
        <HomepageSlotBlock key={`homepage-slot-empty-${slotIndex}`}>
          <HomepageSlotLabel>
            {slot} · {role}
          </HomepageSlotLabel>
          <HomepageSlotEmpty
            onDragOver={(event) => onHomepageSlotDragOver(event, slotIndex)}
            onDragLeave={(event) => onHomepageSlotDragLeave(event, slotIndex)}
            onDrop={(event) => onHomepageSlotDrop(event, slotIndex)}
          >
            {HOMEPAGE_EMPTY_SLOT_HINT}
          </HomepageSlotEmpty>
        </HomepageSlotBlock>
      );
    }

    return (
      <HomepageSlotBlock key={favorite.contentId}>
        <HomepageSlotLabel>
          {slot} · {role}
        </HomepageSlotLabel>
        <HomepageSlotRow
          draggable={canReorderHomepageSlots && !isResolvingFavorite(favorite)}
          $canDrag={canReorderHomepageSlots}
          $isDragging={draggedFavoriteContentId === favorite.contentId}
          $isResolving={isResolvingFavorite(favorite)}
          onDragStart={(event) => onFavoriteDragStart(event, favorite.contentId)}
          onDragEnd={onFavoriteDragEnd}
          onDragOver={(event) => onHomepageSlotDragOver(event, slotIndex)}
          onDragLeave={(event) => onHomepageSlotDragLeave(event, slotIndex)}
          onDrop={(event) => onHomepageSlotDrop(event, slotIndex)}
        >
          <FacilityRowInner>
            <FacilityNameButton
              as="div"
              $canDrag={canReorderHomepageSlots}
              role="button"
              tabIndex={0}
              onClick={(event) => onFavoriteItemClick(favorite, event)}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  onFavoriteItemClick(favorite, event);
                }
              }}
            >
              {getFacilityLabel(favorite)}
            </FacilityNameButton>
            {isResolvingFavorite(favorite) && (
              <FacilityRowSpinnerWrap>
                <Spinner
                  as="span"
                  variant="light"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-label="Loading facility location"
                />
              </FacilityRowSpinnerWrap>
            )}
            <OverlayTrigger
              placement="left"
              delay={{ show: 250, hide: 100 }}
              overlay={
                <Tooltip id={`demote-sidebar-${favorite.contentId}`} className="cmn-ai-earth-tooltip">
                  {REMOVE_FROM_HOMEPAGE_TOOLTIP}
                </Tooltip>
              }
            >
              <SlotActionButton
                type="button"
                aria-label={REMOVE_FROM_HOMEPAGE_TOOLTIP}
                onClick={async (event) => {
                  showHomepagePendingToast(HOMEPAGE_TOAST_REMOVING);
                  if (await handleDemoteFromHomepage(favorite.contentId, event)) {
                    completeHomepagePendingToast(HOMEPAGE_TOAST_REMOVED);
                  } else {
                    dismissHomepagePendingToast();
                  }
                }}
              >
                <ArrowDownwardIcon fontSize="small" />
              </SlotActionButton>
            </OverlayTrigger>
          </FacilityRowInner>
        </HomepageSlotRow>
      </HomepageSlotBlock>
    );
  };

  const renderFacilitiesPanel = () => (
    <>
      <HomepageSection
        $compact={isFacilitiesPanelCompact}
        onDragOver={(event) => event.preventDefault()}
      >
        {!isFacilitiesPanelCompact && (
          <>
            <HomepageSectionTop>
              <SectionSubheading>{homepageSectionTitle()}</SectionSubheading>
              <HomepageCountBadge>
                {formatHomepageSelectedCount(homepageSelectedCount)}
              </HomepageCountBadge>
            </HomepageSectionTop>
            <HomepageSectionHint>{HOMEPAGE_PANEL_HINT}</HomepageSectionHint>
            {canReorderHomepageSlots && (
              <HomepageSectionHint>{HOMEPAGE_DRAG_REORDER_HINT}</HomepageSectionHint>
            )}
          </>
        )}
        {homepageIsLoading ? (
          <HomepageSectionLoader aria-label="Loading homepage facilities">
            {renderFavoritesSpinner()}
          </HomepageSectionLoader>
        ) : (
          Array.from({ length: HOMEPAGE_FACILITY_SLOT_COUNT }).map((_, slotIndex) =>
            renderHomepageSlot(slotIndex)
          )
        )}
      </HomepageSection>

      <AllFacilitiesSection $compact={isFacilitiesPanelCompact}>
        <AllFacilitiesHeader>
          <SectionSubheading>{ALL_FACILITIES_SECTION}</SectionSubheading>
          {savedFacilityCount > 0 && (
            <AllFacilitiesCount>{savedFacilityCount} saved</AllFacilitiesCount>
          )}
        </AllFacilitiesHeader>
        {allFacilitiesInitialLoading ? (
          <AllFacilitiesLoader aria-label="Loading all facilities">
            {renderFavoritesSpinner()}
          </AllFacilitiesLoader>
        ) : (
        <ButtonFav
          ref={favoritesListRef}
          onScroll={handleFavoritesScroll}
          onDragOver={(event) => event.preventDefault()}
          onDrop={onFavoriteListDrop}
        >
          {myFavList.length > 0 ? (
            allFacilitiesDisplayList.map((favorite) => {
              const isHomepageFacility = isHomepageFavorite(myFavList, favorite.contentId);
              return (
              <AllFacilityListItem
                key={favorite.contentId}
                draggable={false}
                $isDragging={false}
                $isResolving={isResolvingFavorite(favorite)}
                onClick={(event) => onFavoriteItemClick(favorite, event)}
                role="button"
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    onFavoriteItemClick(favorite, event);
                  }
                }}
              >
                <FacilityRowInner>
                  <FacilityNameButton as="div">
                    {getFacilityLabel(favorite)}
                  </FacilityNameButton>
                  {isResolvingFavorite(favorite) && (
                    <FacilityRowSpinnerWrap>
                      <Spinner
                        as="span"
                        variant="light"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-label="Loading facility location"
                      />
                    </FacilityRowSpinnerWrap>
                  )}
                  <FacilityRowActions>
                    {isHomepageFacility ? (
                      <HomepageStatusBadge>{SHOWN_ON_HOMEPAGE_BADGE}</HomepageStatusBadge>
                    ) : (
                      <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 100 }}
                        overlay={
                          <Tooltip id={`promote-${favorite.contentId}`} className="cmn-ai-earth-tooltip">
                            {ADD_TO_HOMEPAGE_TOOLTIP}
                          </Tooltip>
                        }
                      >
                        <SlotActionButton
                          type="button"
                          aria-label={ADD_TO_HOMEPAGE_TOOLTIP}
                          onClick={async (event) => {
                            showHomepagePendingToast(HOMEPAGE_TOAST_ADDING);
                            if (await handlePromoteToHomepage(favorite.contentId, event)) {
                              completeHomepagePendingToast(HOMEPAGE_TOAST_ADDED);
                            } else {
                              dismissHomepagePendingToast();
                            }
                          }}
                        >
                          <ArrowUpwardIcon fontSize="small" />
                        </SlotActionButton>
                      </OverlayTrigger>
                    )}
                    <OverlayTrigger
                      placement="left"
                      delay={{ show: 250, hide: 100 }}
                      overlay={
                        <Tooltip id={`delete-${favorite.contentId}`} className="cmn-ai-earth-tooltip">
                          {REMOVE_SAVED_FACILITY_TOOLTIP}
                        </Tooltip>
                      }
                    >
                      <DeleteRowActionButton
                        type="button"
                        aria-label={REMOVE_SAVED_FACILITY_TOOLTIP}
                        onClick={(event) => {
                          event.stopPropagation();
                          event.preventDefault();
                          setFacilityPendingDelete(favorite);
                        }}
                      >
                        <DeleteOutlineIcon fontSize="small" />
                      </DeleteRowActionButton>
                    </OverlayTrigger>
                  </FacilityRowActions>
                </FacilityRowInner>
              </AllFacilityListItem>
              );
            })
          ) : (
            <div className="no-favorites">
              No facilities saved yet. Add a facility to get started.
            </div>
          )}
          {favoritesIsLoadingMore && (
            <AllFacilitiesLoadingMore aria-live="polite">
              <Spinner
                as="span"
                variant="light"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              Loading more...
            </AllFacilitiesLoadingMore>
          )}
          {!favoritesIsLoadingMore &&
            myFavList.length > 0 &&
            myFavList.length < totalFavoriteCount && (
              <AllFacilitiesLoadMoreButton
                type="button"
                onClick={() => void loadRemainingFavoritesPreview()}
              >
                Load more ({myFavList.length} of {totalFavoriteCount})
              </AllFacilitiesLoadMoreButton>
            )}
        </ButtonFav>
        )}
      </AllFacilitiesSection>
    </>
  );

  const addFavoriteRecord = async (record: ISearchRecord) => {
    if (myFavList.some((favorite) => favorite.contentId === record.contentId)) {
      toast.warn('Facility is already in My Facilities.');
      return;
    }

    try {
      await searchFavorite({ type: 'create', record });
      const favList = [...myFavList, record];
      setTotalFavoriteCount((count) => count + 1);
      setMyFavList(favList);
      dispatch(
        updateAIEarth({
          ...aiEarthState,
          favorites: favList,
          favoritesLoaded: true,
        })
      );
      toast.success('Facility added to My Facilities.');
    } catch (error) {
      CeresLogger.error(error as any);
      toast.error('Could not add facility. It may already exist.');
      throw error;
    }
  };

  const removeFavoriteRecord = async (contentId: string) => {
    try {
      await searchFavorite({ type: 'remove', record: { contentId } });
      const favList = myFavList.filter((favorite) => favorite.contentId !== contentId);
      setTotalFavoriteCount((count) => Math.max(0, count - 1));
      setMyFavList(favList);
      dispatch(
        updateAIEarth({
          ...aiEarthState,
          favorites: favList,
          favoritesLoaded: true,
        })
      );
      if (selectedRecord?.contentId === contentId) {
        setSelectedRecord('');
        setShowRecordOptions(false);
        const clearPath = buildMyTundraPath();
        if (`${location.pathname}${location.search}` !== clearPath) {
          history.replace(clearPath);
        }
      }
      if (props.activeMarkerRecord?.contentId === contentId) {
        props.setActiveMarkerRecord(null);
        const clearPath = buildMyTundraPath();
        if (`${location.pathname}${location.search}` !== clearPath) {
          history.replace(clearPath);
        }
      }
      toast.success('Facility removed from My Facilities.');
    } catch (error) {
      CeresLogger.error(error as any);
      toast.error('Could not remove facility.');
      throw error;
    }
  };

  const cancelDeleteFavorite = () => {
    if (!isDeletingFacility) {
      setFacilityPendingDelete(null);
    }
  };

  const confirmDeleteFavorite = async () => {
    if (!facilityPendingDelete || isDeletingFacility) {
      return;
    }

    setIsDeletingFacility(true);
    try {
      await removeFavoriteRecord(facilityPendingDelete.contentId);
      setFacilityPendingDelete(null);
    } catch {
      // removeFavoriteRecord already surfaces errors via toast.
    } finally {
      setIsDeletingFacility(false);
    }
  };

  const syncFavoritesState = useCallback(
    (list: ISearchRecord[], totalItems: number, fullyLoaded: boolean) => {
      favoritesFullyLoadedRef.current = fullyLoaded;
      totalFavoriteCountRef.current = totalItems;
      setTotalFavoriteCount(totalItems);
      setMyFavList(list);
      dispatch(
        updateAIEarth({
          ...aiEarthState,
          favorites: list,
          favoritesLoaded: true,
        })
      );
    },
    [aiEarthState, dispatch]
  );

  const refreshFavoritesInBackground = useCallback(async () => {
    if (favoritesLoadInFlightRef.current || favoritesFullyLoadedRef.current) {
      return;
    }
    favoritesLoadInFlightRef.current = true;
    setFavoritesIsLoadingMore(true);

    try {
      const result = await searchFavorite({
        type: 'getAll',
        pageSize: FACILITIES_INITIAL_PAGE_SIZE,
        lastItemIndex: 0,
        previewOnly: true,
      });
      const payload = result.data as { data?: Record<string, unknown>[]; totalItems?: number };
      const { list, totalItems } = mapFavoritesPayload(payload, true);
      syncFavoritesState(list, totalItems, list.length >= totalItems);
    } catch {
      // Keep cached list on screen.
    } finally {
      favoritesLoadInFlightRef.current = false;
      setFavoritesIsLoadingMore(false);
    }
  }, [syncFavoritesState]);

  const loadRemainingFavoritesPreview = useCallback(async () => {
    if (favoritesFullyLoadedRef.current || favoritesLoadInFlightRef.current) {
      return;
    }
    const startIndex = myFavListRef.current.length;
    if (startIndex >= totalFavoriteCountRef.current && totalFavoriteCountRef.current > 0) {
      favoritesFullyLoadedRef.current = true;
      return;
    }

    favoritesLoadInFlightRef.current = true;
    setFavoritesIsLoadingMore(true);

    try {
      const result = await searchFavorite({
        type: 'getAll',
        pageSize: FACILITIES_NEXT_PAGE_SIZE,
        lastItemIndex: startIndex,
        previewOnly: true,
      });
      const payload = result.data as { data?: Record<string, unknown>[]; totalItems?: number };
      const { list: incoming, totalItems } = mapFavoritesPayload(payload, true);
      const resolvedTotal =
        typeof payload?.totalItems === 'number'
          ? payload.totalItems
          : totalFavoriteCountRef.current || totalItems;
      const merged = [...myFavListRef.current, ...incoming];
      syncFavoritesState(merged, resolvedTotal, merged.length >= resolvedTotal);
    } catch {
      // Keep whatever is already on screen.
    } finally {
      favoritesLoadInFlightRef.current = false;
      setFavoritesIsLoadingMore(false);
    }
  }, [syncFavoritesState]);

  const loadAllFavorites = useCallback(async () => {
    if (favoritesLoadInFlightRef.current) {
      return;
    }
    favoritesLoadInFlightRef.current = true;
    setFavoritesIsLoading(true);
    try {
      const result = await searchFavorite({ type: 'getAll', pageSize: 500, lastItemIndex: 0 });
      const { list, totalItems } = mapFavoritesPayload(
        result.data as { data?: Record<string, unknown>[]; totalItems?: number },
        false
      );
      syncFavoritesState(list, totalItems, true);
    } catch {
      if (Array.isArray(aiEarthState.favorites) && aiEarthState.favorites.length > 0) {
        const cached = normalizeFavoriteList(aiEarthState.favorites as ISearchRecord[]);
        syncFavoritesState(cached, cached.length, false);
      }
    } finally {
      favoritesLoadInFlightRef.current = false;
      setFavoritesIsLoading(false);
      setFavoritesIsLoadingMore(false);
    }
  }, [aiEarthState.favorites, syncFavoritesState]);

  const ensureAllFavoritesLoaded = useCallback(async () => {
    const needsMore =
      !favoritesFullyLoadedRef.current ||
      (totalFavoriteCountRef.current > 0 &&
        myFavListRef.current.length < totalFavoriteCountRef.current);
    if (!needsMore || favoritesLoadInFlightRef.current) {
      return;
    }

    favoritesLoadInFlightRef.current = true;
    setFavoritesIsLoadingMore(true);

    try {
      let merged = [...myFavListRef.current];
      let startIndex = merged.length;
      let resolvedTotal = totalFavoriteCountRef.current;

      while (true) {
        const result = await searchFavorite({
          type: 'getAll',
          pageSize: FACILITIES_NEXT_PAGE_SIZE,
          lastItemIndex: startIndex,
          previewOnly: true,
        });
        const payload = result.data as { data?: Record<string, unknown>[]; totalItems?: number };
        const { list: incoming, totalItems: pageTotalItems } = mapFavoritesPayload(payload, true);

        if (typeof payload?.totalItems === 'number') {
          resolvedTotal = payload.totalItems;
        } else if (pageTotalItems > 0) {
          resolvedTotal = pageTotalItems;
        }

        if (!incoming.length) {
          break;
        }

        merged = mergeFavoritesByContentId(merged, incoming);
        startIndex = merged.length;

        if (resolvedTotal > 0 && merged.length >= resolvedTotal) {
          break;
        }
        if (incoming.length < FACILITIES_NEXT_PAGE_SIZE) {
          break;
        }
      }

      const totalItems = resolvedTotal > 0 ? resolvedTotal : merged.length;
      syncFavoritesState(merged, totalItems, merged.length >= totalItems);
    } catch {
      // Keep whatever is already on screen.
    } finally {
      favoritesLoadInFlightRef.current = false;
      setFavoritesIsLoadingMore(false);
    }
  }, [syncFavoritesState]);

  const handleFavoritesScroll = (event: React.UIEvent<HTMLDivElement>) => {
    if (
      favoritesFullyLoadedRef.current ||
      favoritesIsLoadingMore ||
      favoritesIsLoading ||
      favoritesLoadInFlightRef.current
    ) {
      return;
    }
    const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;
    if (
      scrollTop + clientHeight >= scrollHeight - 24 &&
      myFavListRef.current.length < totalFavoriteCount
    ) {
      void loadRemainingFavoritesPreview();
    }
  };

  // When the taller panel fits the first page, infinite-scroll never fires.
  // Keep loading pages until the list overflows (or everything is loaded).
  useEffect(() => {
    if (
      showRecordOptions ||
      favoritesIsLoading ||
      favoritesIsLoadingMore ||
      favoritesFullyLoadedRef.current ||
      favoritesLoadInFlightRef.current ||
      myFavList.length === 0 ||
      myFavList.length >= totalFavoriteCount
    ) {
      return;
    }

    const listEl = favoritesListRef.current;
    if (!listEl) {
      return;
    }

    const needsFill = listEl.scrollHeight <= listEl.clientHeight + 8;
    if (needsFill) {
      void loadRemainingFavoritesPreview();
    }
  }, [
    showRecordOptions,
    favoritesIsLoading,
    favoritesIsLoadingMore,
    myFavList.length,
    totalFavoriteCount,
    loadRemainingFavoritesPreview,
  ]);

  const bootstrapFavorites = useCallback(() => {
    if (sessionStorage.getItem('myTundraLoadAllFavorites')) {
      if (!favoritesBootstrapStartedRef.current) {
        favoritesBootstrapStartedRef.current = true;
        sessionStorage.removeItem('myTundraLoadAllFavorites');
        void loadAllFavorites();
      }
      return;
    }

    if (favoritesBootstrapStartedRef.current) {
      return;
    }

    if (!aiEarthState.favoritesLoaded) {
      return;
    }

    favoritesBootstrapStartedRef.current = true;

    const favorites = aiEarthState.favorites;
    if (Array.isArray(favorites) && favorites.length > 0) {
      const cached = normalizeFavoriteList(favorites as ISearchRecord[]);
      myFavListRef.current = cached;
      setMyFavList(cached);
      totalFavoriteCountRef.current = cached.length;
      setTotalFavoriteCount(cached.length);
      setFavoritesIsLoading(false);
      void refreshFavoritesInBackground();
      return;
    }

    setFavoritesIsLoading(false);
    favoritesFullyLoadedRef.current = true;
  }, [
    aiEarthState.favorites,
    aiEarthState.favoritesLoaded,
    loadAllFavorites,
    refreshFavoritesInBackground,
  ]);

  useEffect(() => {
    bootstrapFavorites();
  }, [bootstrapFavorites]);

  useEffect(() => {
    myFavListRef.current = myFavList;
  }, [myFavList]);

  useEffect(() => {
    const handlePointerUp = () => {
      const draggedId = draggedFavoriteContentIdRef.current;
      if (!draggedId || favoriteDragFinalizeRef.current) {
        return;
      }
      window.requestAnimationFrame(() => {
        if (
          favoriteDragFinalizeRef.current
          || draggedFavoriteContentIdRef.current !== draggedId
        ) {
          return;
        }
        void finalizeFavoriteDragRef.current(draggedId);
      });
    };

    window.addEventListener('pointerup', handlePointerUp);
    return () => {
      window.removeEventListener('pointerup', handlePointerUp);
      document.body.classList.remove('my-tundra-favorite-dragging');
    };
  }, []);

  useEffect(() => {
    if (!gMap || !gMaps || myFavList.length === 0) {
      return;
    }
    void applyMyTundraPendingFavorite();
  }, [gMap, gMaps, myFavList, applyMyTundraPendingFavorite]);

  useEffect(() => {
    if (!gMap || !gMaps || !firstZoom || myFavList.length === 0) {
      return;
    }
    if (
      sessionStorage.getItem('myTundraPendingFavorite') ||
      pendingFavoriteAppliedRef.current ||
      parseMyTundraSiteFromSearch(location.search)
    ) {
      return;
    }
    void (async () => {
      zoomFirstFavorite();
      setFirstZoom(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myFavList, gMap, gMaps, firstZoom]);

  useEffect(() => {
    return () => {
      pendingFavoriteAppliedRef.current = false;
      appliedSiteKeyRef.current = null;
    };
  }, []);

  useEffect(() => {
    if(selectedRecordOption === 'Agency Documents') {
      setRelatedRecordIndex(0);
    }
  }, [selectedRecordOption]);

  useEffect(() => {
    if(mapType !== 'jobs') {
      return;
    }

    const getEsaData = () => {
      try {
        jobState.activeJob.execute = false;
        dispatch(
          updateJob({
            ...jobState,
            ...{
              esaData: [],
              isLoadEsaData: false,
            },
          })
        );
        axios
          .get(`${process.env.REACT_APP_CERES_URL}/getEsaDataPhase1?v_rn_number=${selectedRecord ? selectedRecord.entityNumber : myFavList[0].entityNumber}`)
          .then((response) => {
            if (response.data) {
              const esajson = response.data[0];
              if (Object.keys(esajson.esadata).length > 0) {
                let jsonArray: any = '';
                const entPoint = esajson.esadata.regulated_entities_point.features;
                if (Object.keys(entPoint).length > 0) {
                  for (const val of entPoint) {
                    if (jsonArray) {
                      jsonArray = jsonArray.concat([val.properties]);
                    } else {
                      jsonArray = [val.properties];
                    }
                  }
                }
                dispatch(
                  updateJob({
                    ...jobState,
                    ...{
                      esaData: esajson.esadata,
                      mapFindings: jsonArray,
                      isLoadEsaData: true,
                      jobInit: false,
                      mapFindingTab: false,
                      jobFeatureTab: false,
                      jobFeature: {},
                    },
                  })
                );
              }
            }
          })
          .catch((err) => {
            dispatch(
              updateJob({
                ...jobState,
                ...{
                  isLoadEsaData: true,
                  esaData: {},
                },
              })
            );
            CeresLogger.error(err);
            return toast.error(`Data is processing please try later.`);
          });
      } catch (e) {
        CeresLogger.error(e);
      }
    };

    getEsaData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRecord, mapType]);

  useEffect(() => {
    const getComplianceData = async () => {
      const response = await axios.get(`${process.env.REACT_APP_CERES_URL}/TCEQRNREID?v_rn=${selectedRecord.entityNumber}`);
      setComplianceData(response.data);
    };

    if(selectedRecord.entityNumber) {
      getTundraButtonVisibilityData();
    }
    getComplianceData();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRecord]);

  const getTundraButtonVisibilityData = async () => {
    const tundraButtonData = await axios.get(`${process.env.REACT_APP_CERES_URL}/myTundraButtons?v_entity_number=${selectedRecord.entityNumber}`);
    const tundraButtonArray = tundraButtonData.data;
    if(tundraButtonArray.length > 0 && favButtons.length > 0) {
      const buttonArray = favButtons.filter((el: any) => {
        const index = tundraButtonArray.findIndex((x: any) => x.button_name === el.name && x.button_status);
        return index >= 0;
      });
      setOptionsList(buttonArray);
    }
  };

  const useClickOutside = (handler: any) => {
    // tslint:disable-next-line:no-shadowed-variable
    const main: any = useRef(null);
    useEffect(() => {
      const maybeHandler = (event: any) => {
        if (main && main.current && !main.current.contains(event.target)) {
          handler();
        }
      };

      document.addEventListener('mousedown', maybeHandler);

      return () => {
        document.removeEventListener('mousedown', maybeHandler);
      };
    });

    return main;
  };

  const main = useClickOutside(() => {
    setIframeUrl('');

  });

  const handleBackButton = (e: any) => {
    // flag use to clear chat data when user visit enviro page not from here
    localStorage.setItem('isBackToEnviroPage', 'true');
    history.replace('myenviroai');
  };

  return	(
    <FacilityModeDataProvider activeMarkerRecord={props.activeMarkerRecord ?? null}>
    <MyTundraWrapper>
      {!showRecordOptions && (<FavoritesContainer>
          <FacilitiesHeader>
            <FacilitiesTitleRow>
              <h2>My Facilities</h2>
              {isSavingFavoriteOrder && (
                <FacilitiesSavingIndicator aria-live="polite">
                  <Spinner
                    as="span"
                    variant="light"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Saving...
                </FacilitiesSavingIndicator>
              )}
              {resolvingFacilityContentId && (
                <FacilitiesSavingIndicator aria-live="polite">
                  <Spinner
                    as="span"
                    variant="light"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Loading location...
                </FacilitiesSavingIndicator>
              )}
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 100 }}
                overlay={
                  <Tooltip id="my-tundra-facility-reorder-info" className="cmn-ai-earth-tooltip">
                    {HOMEPAGE_INSTRUCTIONS.join(' ')}
                  </Tooltip>
                }
              >
                <FacilitiesInfoButton
                  type="button"
                  aria-label="How homepage facility selection works"
                >
                  <InfoOutlinedIcon fontSize="small" />
                </FacilitiesInfoButton>
              </OverlayTrigger>
            </FacilitiesTitleRow>
            <FacilitiesHeaderActions>
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 100 }}
                overlay={
                  <Tooltip id="my-tundra-add-facility" className="cmn-ai-earth-tooltip">
                    <span className="cmn-ai-earth-tooltip__title">{MANAGE_FACILITIES_TITLE}</span>
                    <span className="cmn-ai-earth-tooltip__helper">{MANAGE_FACILITIES_TOOLTIP_HELPER}</span>
                  </Tooltip>
                }
              >
                <AddFacilityIconButton
                  type="button"
                  onClick={() => {
                    setAddFacilityModalTab('search-facilities');
                    setShowAddFacilityModal(true);
                  }}
                  aria-label={MANAGE_FACILITIES_ARIA_LABEL}
                >
                  <AddIcon />
                </AddFacilityIconButton>
              </OverlayTrigger>
            </FacilitiesHeaderActions>
          </FacilitiesHeader>
          {!isFacilitiesPanelCompact && (
            <FacilitiesPanelInstruction>
              {MY_FACILITIES_INSTRUCTION}
            </FacilitiesPanelInstruction>
          )}
          {renderFacilitiesPanel()}
        </FavoritesContainer>
      )}
      {showRecordOptions && (
        <RecordDetailsContainer>
          <MyTundraFavoriteButtons
              selectedRecord={selectedRecord}
              onCloseFacility={clearActiveFacility}
              setSelectedRecordOption={setSelectedRecordOption}
              setShowCustomizeButtons={setShowCustomizeButtons}
              setIframeUrl={setIframeUrl}
              optionsList={optionsList}
              setcopySnackbar={setCopySnackbar}
              setIframeSpinner={setIframeSpinner}
              setOptionsList={setOptionsList}
              mapType={mapType}
              setMapType={setMapType}
              selectedButton={selectedButton}
              setSelectedButton={setSelectedButton}
              resetMap={(e: any) => {resetJobMap(); onNavigationItemClickHandle(selectedRecord, e, true);}}
          />
          {
            selectedRecordOption !== '' && getRecordOptionModal()
          }
          { !!relatedDocument &&
            <DocPreviewPanel>
              <ButtonContainer>
                <Button
                  style={{
                    padding: '5px',
                    backgroundColor: commonColors.accent,
                    borderColor: commonColors.accent,
                    color: commonColors.accentText
                  }}
                  onClick={() => {
                    setRelatedDocument(null);
                  }}
                  size="sm"
                >
                  <ChevronLeft />
              </Button>
              </ButtonContainer>
              <DocPreviewContainer>
                <p>
                  Type: <b>{relatedDocument.title}</b>
                </p>
                <p>
                  Release Date: <b>{relatedDocument.releaseDate}</b>
                </p>
                <p>
                  Category: <b>{relatedDocument.seriesName}</b>
                </p>
                <p>
                  <Button
                    style={{
                      backgroundColor: commonColors.accent,
                      borderColor: commonColors.accent,
                      color: commonColors.accentText,
                      fontWeight: 600,
                      borderRadius: '10px'
                    }}
                    onClick={() => {
                      if (!context.isAuthenticated) {
                        return toast.warn(
                          <span>
                            Please <Alert.Link href="/login">login</Alert.Link> to download files.
                          </span>,
                          {
                            position: toast.POSITION.BOTTOM_CENTER,
                          }
                        );
                      }
                      if (context.isTier(TIERS.FREE) && !context.isLubrizol()) {
                        return toast.warn(<span>Please upgrade to BASIC or PLATINUM to download files.</span>, {
                          position: toast.POSITION.BOTTOM_CENTER,
                        });
                      }
                      if (doStorageDownload(relatedDocument.entitySource)) {
                        const storageRef = getStorageRef(relatedDocument.entitySource);
                        if (R.isNil(storageRef)) {
                          return toast.error(`Oops, could not find the file.`);
                        }
                        setDownloadTriggers(R.append(relatedDocument.contentId, downloadTriggers));
                        return storageRef
                          .ref(relatedDocument.fileName)
                          .getDownloadURL()
                          .then((url) => window.open(url, '_blank', 'noopener,noreferrer'))
                          .catch((err) => toast.error(err.message))
                          .finally(() => setDownloadTriggers(R.without([relatedDocument.contentId], downloadTriggers)));
                      }
                      if (!relatedDocument.fileUrl) {
                        return toast.warn(
                          <span>
                            No associated file was found for the content id <b>{relatedDocument.contentId}</b>
                          </span>
                        );
                      }
                      window.open(relatedDocument.fileUrl, '_blank');
                    }}
                  >
                    Download
                  </Button>
                </p>
                <ContentTD
                  dangerouslySetInnerHTML={{
                    __html:
                      relatedDocument.hitContent.length > 0
                        ? relatedDocument.hitContent
                            // Remove non-ascii chars.
                            .map((str: string) =>
                              /*eslint no-control-regex: 0*/
                              str.replace(/[^\x00-\x7F]/g, '')
                            )
                            .join('<br />')
                        : '<h3>No Preview Available</h3>',
                  }}
                />
              </DocPreviewContainer>
              <NavButtonsWrapper>
                <MuiButton onClick={() => {
                      if(relatedRecordIndex !== 0) {
                        setRelatedRecordIndex(prev => --prev);
                      }
                    }}>
                  <ArrowBackIosIcon color={relatedRecordIndex ? 'primary' : 'disabled'} />
                </MuiButton>
                <MuiButton onClick={() => setRelatedRecordIndex(prev => ++prev)}>
                  <ArrowForwardIosIcon color="primary" />
                </MuiButton>
              </NavButtonsWrapper>
            </DocPreviewPanel>
          }
          {
            showCustomizeButtons && <ButtonOptions
              optionsList={optionsList}
              setOptionsList={setOptionsList}
              setShowCustomizeButtons={setShowCustomizeButtons}
            />
          }
          {
            iFrameUrl.length > 0 && iframeEligibility() && (<div  ref={main} className={`iframe-container ${iFrameExpanded ? 'iframe-container__expanded' : ''}`}>
              <FiMaximize2 className="max-btn" style={{visibility: !iFrameExpanded ? 'visible' : 'hidden'}} onClick={() => setIFrameExpanded(true)} />
              <FiMinimize2 className="max-btn" style={{visibility: iFrameExpanded ? 'visible' : 'hidden'}} onClick={() => setIFrameExpanded(false)} />
              <button className="close-iframe" onClick={() => setIframeUrl('')}>X</button>
              <Snackbar
                open={copySnackbar}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                autoHideDuration={10000}
                onClose={handleClose}
              >
                {<AlertMessage
                  onClose={handleClose}
                  severity="info"
                  text="Site Address is copied to clipboard, you can paste in search bar"
                />}
              </Snackbar>
                {IframeSpinner && noIframeSpinner() ? (
                  <SpinnerContainer>
                <Spinner
                as="span"
                variant="primary"
                animation="border"
                role="status"
                aria-hidden="true"
                   />
              </SpinnerContainer>
                 ) : null}
              <iframe
                onLoad={hideIframeSpinner}
                src={iFrameUrl + getIframeQueryParams()}
                title="myTundraIframe"
                className={isNativeDarkIframe(iFrameUrl) ? 'iframe-native-dark' : 'iframe-white-text'}
                style={{
                  height: '100%',
                  width: `${
                    selectedRecordOption.includes('Permit') ||
                    selectedRecordOption.includes('Deadline') ||
                    selectedRecordOption.includes('CAER') ||
                    iFrameUrl.includes('liputra.com')
                      ? '39vw'
                      : '55vw'
                  }`,
                  border: 'none'
                }}
                name="myIframe"
                height="300px"
                width="100%"
              ></iframe>
            </div>)
          }
        {mapType === 'jobs' && (jobState.mapFindingTab || jobState.jobFeatureTab) && (
          <MyTundraMapsFinding
            doStorageDownload={doStorageDownload}
            getStorageRef={getStorageRef}
            context={context}
            setDownloadTriggers={setDownloadTriggers}
            downloadTriggers={downloadTriggers}
            gMap={gMap}
            gMaps={gMaps}
            selectedEntityNumber={selectedRecord.entityNumber}
            mapFindingAutoScroll={mapFindingAutoScroll}
            onMapFindingAutoScrollConsumed={() => setMapFindingAutoScroll(false)}
          />
        )}
        </RecordDetailsContainer>
      )}
      {/* { mapType === 'jobs' && getJobsMap()} */}
      {(!props.showProgramQueryPanel || jobState.jobInit || aiEarthState.mainDrawer !== '') && (
        <Col
          className="px-0"
          lg={
            (jobState.jobInit ||
            jobState.jobFeatureTab ||
            jobState.mapFindingTab ||
            aiEarthState.mainDrawer !== ''
              ? props.showDocPanel
                ? 4
                : 12
              : 12) + (aiEarthState.isCollapse ? 2 : 0)
          }
          sm={12}
        >
          <MyTundraMapContainer>
            {(context.isTier(TIERS.SUPER_ADMIN) || ((context.isTier(TIERS.PLATINUM) || context.isTier(TIERS.DAYPASS)) && context.isAuthenticated) || (context.isLubrizol() && context.isAuthenticated)) && (
              <MyTundraMap
                records={myFavList}
                programQueryEPNResult={props.programQueryEPNResult}
                showNavigation={showNavigation}
                setShowNavigation={setShowNavigation}
                showProgramQueryPanel={props.showProgramQueryPanel}
                boundingBox={props.boundingBox}
                showProgramQueryDocPanel={props.showProgramQueryDocPanel}
                setShowProgramQueryDocPanel={props.setShowProgramQueryDocPanel}
                activeMarkerRecord={props.activeMarkerRecord}
                setActiveMarkerRecord={props.setActiveMarkerRecord}
                gMap={gMap}
                setGMap={setGMap}
                gMaps={gMaps}
                setGMaps={setGMaps}
                rectangle={rectangle}
                setRectangle={setRectangle}
                onRectDrag={props.onRectDrag}
                getCenterWithOffset={getCenterWithOffset}
                zoomLevel={zoomLevel}
                setZoomLevel={setZoomLevel}
                setShowDocPanel={props.setShowDocPanel}
                setStreetLocation={setStreetLocation}
                setAutoScroll={setMapFindingAutoScroll}
                setSubjectPropertyEsaData={setSubjectPropertyEsaData}
                resetJobMap={resetJobMap}
                context={context}
                mapType={mapType}
                onOverlayModeChange={handleOverlayModeChange}
                onDischargeFacilityLocationChange={setDischargeFacilityLocation}
                onDischargeOutfallsChange={setDischargeOutfalls}
              />
            )}
          </MyTundraMapContainer>
        </Col>
      )}
      {props.showProgramQueryPanel && (
        <Col
          className="px-0"
          lg={props.showProgramQueryPanel ? (props.showProgramQueryDocPanel ? 4 : 7) : 0}
          sm={12}
        >
          <MyTundraMapContainer>
            {(context.isTier(TIERS.SUPER_ADMIN) || ((context.isTier(TIERS.PLATINUM) || context.isTier(TIERS.DAYPASS)) && context.isAuthenticated) || (context.isLubrizol() && context.isAuthenticated)) && (
              <MyTundraMap
                records={[]}
                programQueryEPNResult={props.programQueryEPNResult}
                showNavigation={showNavigation}
                showProgramQueryPanel={props.showProgramQueryPanel}
                boundingBox={props.boundingBox}
                showProgramQueryDocPanel={props.showProgramQueryDocPanel}
                setShowProgramQueryDocPanel={props.setShowProgramQueryDocPanel}
                setShowNavigation={setShowNavigation}
                activeMarkerRecord={props.activeMarkerRecord}
                setActiveMarkerRecord={props.setActiveMarkerRecord}
                gMap={gMap}
                setGMap={setGMap}
                gMaps={gMaps}
                setGMaps={setGMaps}
                rectangle={rectangle}
                setRectangle={setRectangle}
                onRectDrag={props.onRectDrag}
                getCenterWithOffset={getCenterWithOffset}
                zoomLevel={zoomLevel}
                setZoomLevel={setZoomLevel}
                setShowDocPanel={props.setShowDocPanel}
                setStreetLocation={setStreetLocation}
                setAutoScroll={setMapFindingAutoScroll}
                resetJobMap={resetJobMap}
                context={context}
                mapType={mapType}
                onOverlayModeChange={handleOverlayModeChange}
                onDischargeFacilityLocationChange={setDischargeFacilityLocation}
                onDischargeOutfallsChange={setDischargeOutfalls}
              />
            )}
          </MyTundraMapContainer>
        </Col>
      )}
      <SearchContainer>
        {/* <InputGroup className="search-box">
          <div className="input-group-append left-icon">
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={<Tooltip id="tooltip">Enviro AI</Tooltip>}
            >
              <Button
                variant="link"
                className="px-0"
              >
                <img src={EnviroAiTriangleIcon} alt="Enviro Ai Logo" />
              </Button>
            </OverlayTrigger>
          </div>
          <input
            type="text"
            name="message"
            value={searchWord}
            className="form-control"
            placeholder="Not the correct facility or interested in a different facility? Search here..."
            onChange={(e: any) => setSearchWord(e.target.value)}
            autoFocus
          />
          <div className="input-group-append right-icon">
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={<Tooltip id="tooltip">Send Message</Tooltip>}
            >
              <Button
                variant="link"
                className="px-0"
              >
                <Search />
              </Button>
            </OverlayTrigger>
          </div>
        </InputGroup> */}
        {isBackButton && <Button variant="primary" className="back-btn" size="lg" onClick={handleBackButton}>Back</Button>}
      </SearchContainer>
      <AddFacilityModal
        open={showAddFacilityModal}
        initialTab={addFacilityModalTab}
        mode="manage"
        onClose={() => setShowAddFacilityModal(false)}
        onRequestAllFavorites={ensureAllFavoritesLoaded}
        totalFavoriteCount={totalFavoriteCount}
        favoritesLoading={favoritesIsLoading || favoritesIsLoadingMore}
        onAdd={addFavoriteRecord}
        onRemove={removeFavoriteRecord}
        onPromoteToHomepage={(contentId) => handlePromoteToHomepage(contentId)}
        onDemoteFromHomepage={(contentId) => handleDemoteFromHomepage(contentId)}
        onReorderHomepageSlot={(draggedContentId, targetSlotIndex) =>
          handleReorderHomepageSlot(draggedContentId, targetSlotIndex)
        }
        isHomepageOrderSaving={isSavingFavoriteOrder}
        favoriteContentIds={myFavList.map((favorite) => favorite.contentId)}
        favorites={myFavList}
      />
      <Modal
        show={!!facilityPendingDelete}
        onHide={cancelDeleteFavorite}
        centered
        backdrop={isDeletingFacility ? 'static' : true}
        keyboard={!isDeletingFacility}
        className="cmn-delete-facility-modal"
        dialogClassName="cmn-delete-facility-modal__dialog"
        contentClassName="cmn-delete-facility-modal__content"
        backdropClassName="cmn-delete-facility-modal__backdrop"
      >
        <Modal.Header closeButton={!isDeletingFacility}>
          <Modal.Title>{DELETE_FACILITY_CONFIRM_TITLE}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {facilityPendingDelete
            ? formatDeleteFacilityConfirmBody(getFacilityLabel(facilityPendingDelete))
            : null}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={cancelDeleteFavorite}
            disabled={isDeletingFacility}
          >
            {DELETE_FACILITY_CONFIRM_CANCEL}
          </Button>
          <Button
            variant="danger"
            onClick={() => void confirmDeleteFavorite()}
            disabled={isDeletingFacility}
          >
            {isDeletingFacility ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Removing...
              </>
            ) : (
              DELETE_FACILITY_CONFIRM_ACTION
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <FacilityChatBubble />
    </MyTundraWrapper>
    </FacilityModeDataProvider>
  );
};

export default withAuthContext(MyTundraContainer);
